//
//  TRIGGER TYPE: 'DEFAULT'
//  TRIGGER TYPE: 'DEFAULT'
//  TRIGGER TYPE: 'DEFAULT'
//
const triggerTexts = {};

triggerTexts[0] = {
  SE: {
    enum_key: 'Result',
    trigger_id: 0,
    trigger_type: 'DEFAULT',
    name: 'Sviktande eller otillräckligt resultat',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har sviktande eller otillräckligt resultat betyder det
          att företaget inte genererar tillräcklig vinst för att täcka sina
          kostnader eller skapa hållbara ekonomiska förutsättningar. Det kan
          indikera finansiella problem eller att bolaget inte har en effektiv
          affärsmodell.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Analysera kassaflödet: Se om företaget har tillräckliga medel för
              att klara sina löpande betalningar.
            </p>
          </li>
          <li>
            <p>
              Undersök orsaker till sviktande resultat: Är det tillfälliga
              problem eller långsiktiga strukturella brister?
            </p>
          </li>
          <li>
            <p>
              Bedöm återhämtningsplanen: Har bolaget åtgärder för att förbättra
              lönsamheten och säkerställa långsiktig stabilitet?
            </p>
          </li>
          <li>
            <p>
              Granska skulder och finansiella åtaganden: Om bolaget har svårt
              att generera vinst, kan det vara svårt att betala tillbaka lån
              eller skulder.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör man vara särskilt försiktig med företag med
          sviktande resultat, men samtidigt bedöma om de har en realistisk plan
          för att återhämta sig och om risken är hanterbar.
        </p>
      </div>
    ),
  },
};

triggerTexts[1] = {
  SE: {
    enum_key: 'Invoices',
    trigger_id: 1,
    trigger_type: 'DEFAULT',
    name: 'Finns ej bokförda fakturor',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har fakturor som inte blivit bokförda, utan endast ligger
          som utkast eller saknar attest, innebär detta att företagets bokföring
          inte är uppdaterad eller korrekt. Det kan tyda på bristande ekonomisk
          kontroll och förmåga att hantera sina affärstransaktioner på ett
          ordnat sätt.
        </p>
        <p>Möjliga orsaker:</p>
        <ul>
          <li>
            <p>
              Brister i bokföringsrutiner: Bolaget kan ha ineffektiva eller
              otillräckliga rutiner för att hantera och bokföra fakturor i tid.
            </p>
          </li>
          <li>
            <p>
              Kassaflödesproblem: Om företaget har ekonomiska svårigheter kan
              det vara ett tecken på att det inte har medel för att betala
              fakturorna eller att dessa inte hanteras korrekt.
            </p>
          </li>
          <li>
            <p>
              Organisatoriska problem: Om bolaget saknar tillräcklig kontroll
              eller struktur kan fakturor bli försenade eller missade i
              bokföringen.
            </p>
          </li>
          <li>
            <p>
              Medveten försummelse: I vissa fall kan fakturor avsiktligt
              undvikas för att skapa en missvisande bild av bolagets ekonomi
              (t.ex. för att minska skattebelastning eller påverka rapporterade
              resultat).
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska ej bokförda fakturor: Kontrollera vilka fakturor som inte
              har bokförts och be om en förklaring från bolaget om varför detta
              har hänt.
            </p>
          </li>
          <li>
            <p>
              Undersök rutiner: Bedöm bolagets fakturahantering och
              bokföringsprocesser. Har de strukturerade rutiner för att
              säkerställa att fakturor bokförs i tid?
            </p>
          </li>
          <li>
            <p>
              Be om dokumentation: Be om dokumentation som visar hur fakturor
              normalt behandlas och om eventuella åtgärder vidtas för att
              förbättra rutinerna.
            </p>
          </li>
          <li>
            <p>
              Kontrollera kassaflöde: Se om fördröjningen av fakturorna kan
              kopplas till kassaflödesproblem, vilket kan påverka bolagets
              betalningsförmåga.
            </p>
          </li>
          <li>
            <p>
              Attestprocessen: Säkerställ att alla fakturor som inte har attest
              får rätt godkännande och blir bokförda snarast möjligt.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på obokförda fakturor,
          eftersom det kan vara ett tecken på bristande ordning och ekonomisk
          kontroll. Det är viktigt att säkerställa att bolaget har tillräcklig
          struktur för att hantera sina affärer korrekt, annars kan det indikera
          en högre risk för långivaren.
        </p>
      </div>
    ),
  },
};

triggerTexts[2] = {
  SE: {
    enum_key: 'Accruals',
    trigger_id: 2,
    trigger_type: 'DEFAULT',
    name: 'Periodiseringar ej utförda',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har periodiseringar som inte blivit bokförda, innebär det
          att intäkter eller kostnader som ska fördelas över en viss period inte
          har redovisats korrekt. Detta kan skapa en missvisande bild av
          bolagets ekonomiska ställning och resultat.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska periodiseringarna: Kontrollera vilka periodiseringar som
              inte har bokförts och varför detta inte har gjorts. Bedöm om detta
              är ett tillfälligt problem eller en systematisk brist i rutinerna.
            </p>
          </li>
          <li>
            <p>
              Undersök interna rutiner: Bedöm om bolaget har tillräckliga och
              effektiva rutiner för att hantera periodiseringar korrekt. Begär
              dokumentation om hur periodiseringarna normalt genomförs.
            </p>
          </li>
          <li>
            <p>
              Be om förklaring: Fråga bolaget varför periodiseringarna inte har
              bokförts och om det finns någon underliggande orsak till
              förseningen.
            </p>
          </li>
          <li>
            <p>
              Kontrollera resultatet: Utvärdera om periodiseringarna har
              påverkat resultatet för det aktuella räkenskapsåret och om detta
              ger en missvisande bild av bolagets verkliga finansiella
              situation.
            </p>
          </li>
          <li>
            <p>
              Säkerställ framtida korrekt hantering: Be om en plan från
              företaget för att säkerställa att periodiseringarna hanteras
              korrekt framöver och att inga ytterligare redovisningsfel uppstår.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara vaksam på ogenomförda periodiseringar
          eftersom de kan skapa en missvisande bild av företagets resultat och
          finansiella ställning. Det är viktigt att säkerställa att bolaget har
          ordentliga rutiner för korrekt bokföring, så att risken för att
          framtida transaktioner inte hanteras korrekt minimeras.
        </p>
      </div>
    ),
  },
};

triggerTexts[3] = {
  SE: {
    enum_key: 'ObservationAccount',
    trigger_id: 3,
    trigger_type: 'DEFAULT',
    name: 'Observationskonto grupp 1',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har summor på observationskonton innebär det att det
          finns belopp som inte har blivit korrekt bokförda på sina respektive
          konton. Observationskonton används vanligtvis för att hålla reda på
          transaktioner som behöver vidare undersökning eller bekräftelse innan
          de kan bokföras korrekt. Om summorna inte hanteras ordentligt kan det
          tyda på bristande ekonomisk kontroll.
        </p>
        <p>Möjliga orsaker:</p>
        <ul>
          <li>
            <p>
              Belopp på observationskonton kan vara resultatet av transaktioner
              som inte har slutgiltigt godkänts eller verifierats.
            </p>
          </li>
          <li>
            <p>
              Bristande bokföringsrutiner: Företaget kan ha otillräckliga eller
              ineffektiva rutiner för att hantera och bokföra transaktioner
              korrekt.
            </p>
          </li>
          <li>
            <p>
              Kassaflödesproblem: Om bolaget har problem med likviditeten kan
              det resultera i att transaktioner hamnar på observationskonton
              medan betalningar eller transaktioner väntas.
            </p>
          </li>
          <li>
            <p>
              Oklara eller tvetydiga transaktioner: Det kan vara otydligheter
              kring vissa transaktioner som behöver vidare utredning, t.ex.
              osäkra kundbetalningar eller ofullständiga fakturor.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska summorna: Kontrollera vilka belopp som finns på
              observationskontona och varför de inte har bokförts på de korrekta
              kontona. Är det ett tillfälligt problem eller en långvarig
              situation?
            </p>
          </li>
          <li>
            <p>
              Utred transaktionerna: Undersök varför transaktionerna ligger på
              observationskonton. Är det några osäkra eller oklara belopp som
              måste undersökas eller verifieras?
            </p>
          </li>
          <li>
            <p>
              Be om förklaring: Fråga bolaget varför belopp hamnat på
              observationskonton och vad som görs för att lösa eventuella
              problem.
            </p>
          </li>
          <li>
            <p>
              Bedöm tidsramen: Om beloppen ligger på observationskonton under
              längre perioder kan det vara ett tecken på ineffektivitet eller
              bristande uppföljning. Be bolaget att förklara varför det tar så
              lång tid att avsluta transaktionerna.
            </p>
          </li>
          <li>
            <p>
              Kontrollera kassaflöde: Om observationskontona är kopplade till
              kassaflödesproblem, se till att bolaget har en plan för att lösa
              eventuella likviditetsbrister.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara försiktig med företag som har summor på
          observationskonton under längre perioder. Det kan tyda på bristande
          ordning i bokföringen eller potentiella problem med kassaflödet. Det
          är viktigt att få en tydlig förklaring från bolaget och att
          säkerställa att sådana transaktioner hanteras korrekt för att minimera
          risken för långivaren.
        </p>
      </div>
    ),
  },
};

triggerTexts[4] = {
  SE: {
    enum_key: 'ObsvervationAccount2',
    trigger_id: 4,
    trigger_type: 'DEFAULT',
    name: 'Observationskonto grupp 2',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har summor på observationskonton innebär det att det
          finns belopp som inte har blivit korrekt bokförda på sina respektive
          konton. Observationskonton används vanligtvis för att hålla reda på
          transaktioner som behöver vidare undersökning eller bekräftelse innan
          de kan bokföras korrekt. Om summorna inte hanteras ordentligt kan det
          tyda på bristande ekonomisk kontroll.
        </p>
        <p>Möjliga orsaker:</p>
        <ul>
          <li>
            <p>
              Belopp på observationskonton kan vara resultatet av transaktioner
              som inte har slutgiltigt godkänts eller verifierats.
            </p>
          </li>
          <li>
            <p>
              Bristande bokföringsrutiner: Företaget kan ha otillräckliga eller
              ineffektiva rutiner för att hantera och bokföra transaktioner
              korrekt.
            </p>
          </li>
          <li>
            <p>
              Kassaflödesproblem: Om bolaget har problem med likviditeten kan
              det resultera i att transaktioner hamnar på observationskonton
              medan betalningar eller transaktioner väntas.
            </p>
          </li>
          <li>
            <p>
              Oklara eller tvetydiga transaktioner: Det kan vara otydligheter
              kring vissa transaktioner som behöver vidare utredning, t.ex.
              osäkra kundbetalningar eller ofullständiga fakturor.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska summorna: Kontrollera vilka belopp som finns på
              observationskontona och varför de inte har bokförts på de korrekta
              kontona. Är det ett tillfälligt problem eller en långvarig
              situation?
            </p>
          </li>
          <li>
            <p>
              Utred transaktionerna: Undersök varför transaktionerna ligger på
              observationskonton. Är det några osäkra eller oklara belopp som
              måste undersökas eller verifieras?
            </p>
          </li>
          <li>
            <p>
              Be om förklaring: Fråga bolaget varför belopp hamnat på
              observationskonton och vad som görs för att lösa eventuella
              problem.
            </p>
          </li>
          <li>
            <p>
              Bedöm tidsramen: Om beloppen ligger på observationskonton under
              längre perioder kan det vara ett tecken på ineffektivitet eller
              bristande uppföljning. Be bolaget att förklara varför det tar så
              lång tid att avsluta transaktionerna.
            </p>
          </li>
          <li>
            <p>
              Kontrollera kassaflöde: Om observationskontona är kopplade till
              kassaflödesproblem, se till att bolaget har en plan för att lösa
              eventuella likviditetsbrister.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara försiktig med företag som har summor på
          observationskonton under längre perioder. Det kan tyda på bristande
          ordning i bokföringen eller potentiella problem med kassaflödet. Det
          är viktigt att få en tydlig förklaring från bolaget och att
          säkerställa att sådana transaktioner hanteras korrekt för att minimera
          risken för långivaren.
        </p>
      </div>
    ),
  },
};

triggerTexts[5] = {
  SE: {
    enum_key: 'IncomingInvoices',
    trigger_id: 5,
    trigger_type: 'DEFAULT',
    name: 'Ej behandlade fakturor',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>EMPTY EXPLANATION</p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>EMPTY MEASURE</p>
      </div>
    ),
  },
};

triggerTexts[6] = {
  SE: {
    enum_key: 'NonDeductibleExpenses',
    trigger_id: 6,
    trigger_type: 'DEFAULT',
    name: 'Ej avdragsgilla kostnader',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har ej avdragsgilla kostnader innebär det att dessa inte
          kan dras av från bolagets beskattningsbara resultat, vilket påverkar
          den totala skatten som företaget måste betala. Ej avdragsgilla
          kostnader kan till exempel inkludera privata utgifter, böter eller
          representation, vilket är särskilt relevant för säljbolag med
          omfattande representation. Vid årsbokslutet eller i samband med
          årsredovisningen kan detta leda till en högre slutskatt än väntat,
          eftersom skattebelastningen inte minskar med dessa kostnader.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska representationen: Kontrollera hur mycket bolaget spenderar
              på representation och om dessa kostnader är korrekt hanterade
              enligt skattereglerna. För stora utgifter utan rätt hantering kan
              öka skattebördan betydligt vid årsbokslutet.
            </p>
          </li>
          <li>
            <p>
              Undersök skattepåverkan: Bedöm hur dessa ej avdragsgilla kostnader
              påverkar bolagets slutskatt och om detta kan skapa
              likviditetsproblem, särskilt vid årsredovisningen när den
              slutgiltiga skatten fastställs.
            </p>
          </li>
          <li>
            <p>
              Säkerställ kassaflödet: Se till att bolaget har tillräcklig
              likviditet för att täcka den högre skatten om representationen är
              betydande. Be om en plan för hur bolaget hanterar och budgeterar
              för dessa kostnader.
            </p>
          </li>
          <li>
            <p>
              Be om åtgärdsplan: Om bolaget har återkommande problem med ej
              avdragsgilla kostnader, be om en plan för att minska dessa
              kostnader framöver, så att skatten inte påverkar deras ekonomi
              negativt vid årets slut.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt vaksam på hur ej avdragsgilla
          kostnader, såsom representation, kan påverka skatten vid årets slut.
          För säljbolag kan detta skapa betydande likviditetsproblem om den
          slutgiltiga skatten inte har beaktats ordentligt i deras
          kassaflödesplanering. Det är viktigt att bolaget har en strategi för
          att hantera dessa kostnader och säkerställa att de kan betala sina
          skatter utan att äventyra sin förmåga att uppfylla andra finansiella
          åtaganden.
        </p>
      </div>
    ),
  },
};

triggerTexts[7] = {
  SE: {
    enum_key: 'Depreciations',
    trigger_id: 7,
    trigger_type: 'DEFAULT',
    name: 'Avskrivningar är ej gjorda',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte har utfört avskrivningar innebär det att företagets
          anläggningstillgångar inte har skrivits av korrekt över tid.
          Avskrivningar är en redovisningsteknik som fördelar kostnaden för en
          tillgång över dess ekonomiska livslängd. Om avskrivningar inte görs
          kan bolagets resultat se bättre ut än det faktiskt är, eftersom
          kostnaderna för tillgångarna inte syns i resultaträkningen.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska tillgångarna: Kontrollera om bolaget har tillgångar som
              inte har skrivits av korrekt och om detta påverkar resultatet.
              Bedöm om det handlar om en tillfällig miss eller ett mer
              strukturellt problem i bolagets bokföring.
            </p>
          </li>
          <li>
            <p>
              Undersök den långsiktiga påverkan: Bedöm hur uteblivna
              avskrivningar påverkar företagets finansiella hälsa på lång sikt.
              Är det en strategi för att ge ett bättre resultat på kort sikt,
              eller handlar det om ett misstag?
            </p>
          </li>
          <li>
            <p>
              Be om förklaring: Fråga bolaget varför de inte har utfört
              avskrivningar och om det finns en plan för att rätta till detta.
              Är detta ett medvetet beslut eller ett resultat av bristande
              rutiner?
            </p>
          </li>
          <li>
            <p>
              Kontrollera skattesituationen: Se till att bolaget har beaktat
              avskrivningarna för att korrekt beräkna sitt skatteansvar. Ej
              utförda avskrivningar kan skapa problem vid skatterevisioner eller
              retroaktiva skattejusteringar.
            </p>
          </li>
          <li>
            <p>
              Säkerställ finansiell transparens: För att få en korrekt bild av
              företagets lönsamhet och finansiella ställning är det viktigt att
              avskrivningar görs i enlighet med god redovisningssed. Se till att
              bolaget följer riktlinjer för att ge en rättvisande bild av sina
              ekonomiska resultat.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara extra uppmärksam på bolag som inte utför
          avskrivningar, eftersom detta kan ge en missvisande bild av deras
          verkliga resultat och finansiella hälsa. Det är viktigt att
          säkerställa att bolaget har ordentliga rutiner för att korrekt hantera
          sina anläggningstillgångar och att alla kostnader redovisas på ett
          rättvisande sätt, vilket minskar risken för felaktig skatteberäkning
          och långsiktiga ekonomiska problem.
        </p>
      </div>
    ),
  },
};

triggerTexts[8] = {
  SE: {
    enum_key: 'ObservationSum',
    trigger_id: 8,
    trigger_type: 'DEFAULT',
    name: 'Summor på observationskonto',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har summor på observationskonton innebär det att det
          finns belopp som inte har blivit korrekt bokförda på sina respektive
          konton. Observationskonton används vanligtvis för att hålla reda på
          transaktioner som behöver vidare undersökning eller bekräftelse innan
          de kan bokföras korrekt. Om summorna inte hanteras ordentligt kan det
          tyda på bristande ekonomisk kontroll.
        </p>
        <p>Möjliga orsaker:</p>
        <ul>
          <li>
            <p>
              Belopp på observationskonton kan vara resultatet av transaktioner
              som inte har slutgiltigt godkänts eller verifierats.
            </p>
          </li>
          <li>
            <p>
              Bristande bokföringsrutiner: Företaget kan ha otillräckliga eller
              ineffektiva rutiner för att hantera och bokföra transaktioner
              korrekt.
            </p>
          </li>
          <li>
            <p>
              Kassaflödesproblem: Om bolaget har problem med likviditeten kan
              det resultera i att transaktioner hamnar på observationskonton
              medan betalningar eller transaktioner väntas.
            </p>
          </li>
          <li>
            <p>
              Oklara eller tvetydiga transaktioner: Det kan vara otydligheter
              kring vissa transaktioner som behöver vidare utredning, t.ex.
              osäkra kundbetalningar eller ofullständiga fakturor.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska summorna: Kontrollera vilka belopp som finns på
              observationskontona och varför de inte har bokförts på de korrekta
              kontona. Är det ett tillfälligt problem eller en långvarig
              situation?
            </p>
          </li>
          <li>
            <p>
              Utred transaktionerna: Undersök varför transaktionerna ligger på
              observationskonton. Är det några osäkra eller oklara belopp som
              måste undersökas eller verifieras?
            </p>
          </li>
          <li>
            <p>
              Be om förklaring: Fråga bolaget varför belopp hamnat på
              observationskonton och vad som görs för att lösa eventuella
              problem.
            </p>
          </li>
          <li>
            <p>
              Bedöm tidsramen: Om beloppen ligger på observationskonton under
              längre perioder kan det vara ett tecken på ineffektivitet eller
              bristande uppföljning. Be bolaget att förklara varför det tar så
              lång tid att avsluta transaktionerna.
            </p>
          </li>
          <li>
            <p>
              Kontrollera kassaflöde: Om observationskontona är kopplade till
              kassaflödesproblem, se till att bolaget har en plan för att lösa
              eventuella likviditetsbrister.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara försiktig med företag som har summor på
          observationskonton under längre perioder. Det kan tyda på bristande
          ordning i bokföringen eller potentiella problem med kassaflödet. Det
          är viktigt att få en tydlig förklaring från bolaget och att
          säkerställa att sådana transaktioner hanteras korrekt för att minimera
          risken för långivaren.
        </p>
      </div>
    ),
  },
};

triggerTexts[9] = {
  SE: {
    enum_key: 'DebtPercentage',
    trigger_id: 9,
    trigger_type: 'DEFAULT',
    name: 'Hög skuldsättningsgrad',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Skuldsättningsgrad är ett mått på ett företags totala skulder i
          relation till dess eget kapital. Det är en indikator på hur mycket
          företaget har lånat för att finansiera sin verksamhet i jämförelse med
          hur mycket det äger i eget kapital.
        </p>
        <p>
          För långivare innebär en hög skuldsättningsgrad en ökad risk för att
          företaget inte kan återbetala sina skulder om det uppstår ekonomiska
          problem. Långivare kan vara tveksamma till att bevilja nya lån eller
          kan kräva högre räntor för att kompensera för den ökade risken.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Granska skuldstrukturen: Företaget bör noggrant analysera sina skulder
          och överväga att omstrukturera dem om det är möjligt. Det kan innebära
          att byta ut dyra lån mot mer förmånliga lån eller förlänga
          återbetalningstider för att få bättre kontroll över kassaflödena.
        </p>
        <p>
          Öka det egna kapitalet: Företaget kan försöka öka sitt egna kapital
          genom att ta in nytt kapital, exempelvis genom att emittera aktier
          eller få nya investerare. Detta kan minska beroendet av lån och stärka
          företagets finansiella position.
        </p>
        <p>
          Förbättra lönsamheten: Företaget bör fokusera på att öka sina intäkter
          och effektivisera sina kostnader för att förbättra sin lönsamhet och
          minska beroendet av skulder. Större vinster kan också hjälpa till att
          bygga upp eget kapital och minska skuldsättningen över tid.
        </p>
        <p>
          Öka kassaflödet: Genom att säkerställa att företaget har ett starkt
          och stabilt kassaflöde kan det hantera sina skulder bättre. Företaget
          bör t.ex. se till att faktureringen är effektiv och att betalningarna
          från kunderna kommer i tid.
        </p>
        <p>
          Ha en plan för att minska skuldsättningen: Företaget bör skapa en
          långsiktig plan för att minska skuldsättningen, vilket kan innebära
          att betala av lån tidigare än planerat eller fokusera på att öka det
          egna kapitalet. Genom att minska skulderna kan företaget förbättra sin
          finansiella ställning och öka sin kreditvärdighet.
        </p>
      </div>
    ),
  },
};

triggerTexts[10] = {
  SE: {
    enum_key: 'SolidityPercentage',
    trigger_id: 10,
    trigger_type: 'DEFAULT',
    name: 'Låg soliditet',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          En låg soliditet betyder att företaget har en liten andel eget kapital
          i relation till sina totala tillgångar, vilket innebär att en större
          del av finansieringen kommer från externa källor, som lån eller
          krediter. Detta kan vara ett tecken på att företaget är mer skuldsatt
          än önskvärt.
        </p>
        <p>
          Det betyder att företaget är starkt beroende av externa skulder för
          att finansiera sina tillgångar, vilket kan innebära ökad risk för
          finansiella problem, svårigheter att ta nya lån och mindre finansiell
          flexibilitet. För att hantera detta bör företaget fokusera på att öka
          sitt eget kapital, optimera sin skuldstruktur och förbättra
          lönsamheten. För långivare och investerare innebär låg soliditet en
          högre risk, och det är viktigt att noggrant bedöma företagets förmåga
          att hantera sina skulder och driva sin verksamhet framgångsrikt.
        </p>
        <p>
          För långivare innebär en låg soliditet en ökad risk för att företaget
          inte kan betala tillbaka sina lån om det uppstår finansiella problem.
          Det kan även vara tecken på att företaget har svårt att få kapital
          från andra källor, vilket ökar risken för misslyckande på lång sikt.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Öka det egna kapitalet: Företaget kan överväga att ta in nytt kapital
          genom att emittera aktier eller få nya investerare, vilket ökar den
          egna finansieringen och därmed soliditeten. Ett stabilare eget kapital
          kan göra det lättare att få lån och förbättra företagets
          kreditvärdighet.
        </p>
        <p>
          Granska skuldstrukturen: Företaget bör noggrant analysera sina skulder
          och överväga att omstrukturera dem om det är möjligt, t.ex. genom att
          förlänga återbetalningstider eller byta till billigare finansiering.
        </p>
        <p>
          Öka lönsamheten: Företaget bör fokusera på att förbättra sin lönsamhet
          för att stärka eget kapital och minska beroendet av lån. Genom att
          förbättra intäkterna och effektivisera kostnaderna kan företaget börja
          bygga upp ett större eget kapital över tid.
        </p>
        <p>
          Följ finansiella mål noggrant: Företaget bör sätta upp finansiella mål
          för att gradvis förbättra soliditeten och skapa en mer balanserad
          kapitalstruktur. Detta kan innebära att man arbetar för att minska
          skulder eller öka eget kapital genom årliga vinster.
        </p>
        <p>
          Bedöm riskerna noga: En låg soliditet innebär att företaget har högre
          riskexponering, så det är viktigt att noggrant bedöma vilka externa
          faktorer som kan påverka företagets ekonomi, t.ex.
          marknadsförändringar, räntor eller förlorade affärsmöjligheter.
        </p>
      </div>
    ),
  },
};

triggerTexts[11] = {
  SE: {
    enum_key: 'LateVoucher',
    trigger_id: 11,
    trigger_type: 'DEFAULT',
    name: '45+ dagar sedan senast bokfört datum',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte har bokfört några transaktioner på mer än 45 dagar
          kan detta vara ett tecken på allvarliga problem med företagets interna
          ekonomiska processer eller att verksamheten inte rullar som förväntat.
          En lång period utan bokföring kan indikera bristande ekonomisk
          kontroll, försämrad likviditet eller att företaget inte bedrivit någon
          verksamhet under denna tid. En annan möjlig förklaring är att
          företaget avsiktligt undviker bokföring för att dölja ett dåligt
          resultat och ge ett bättre intryck när de söker finansiering eller
          lån.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till utebliven bokföring: Be företaget förklara
              varför bokföring uteblir. Är det ett kassaflödesproblem eller
              medveten undvikelse för att dölja dåliga resultat inför
              låneansökan?
            </p>
          </li>
          <li>
            <p>
              Bedöm likviditet: Kontrollera om företaget har tillräcklig
              likviditet för att täcka sina kortsiktiga förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Undersök verksamhetens status: Bedöm om företaget fortfarande är
              aktivt eller om verksamheten har pausats.
            </p>
          </li>
          <li>
            <p>
              Följ upp interna rutiner: Kontrollera om företaget har ordning på
              sina bokföringsrutiner och resurser för att hålla bokföringen
              uppdaterad.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam om ett bolag inte har
          bokfört något på mer än 45 dagar. Detta kan vara ett tecken på
          likviditetsproblem, bristande ekonomisk styrning eller att företaget
          inte längre bedriver någon verksamhet. Det kan även vara ett tecken på
          att företaget medvetet försöker dölja ett dåligt resultat för att ge
          ett bättre intryck inför en låneansökan. Det är avgörande att förstå
          orsakerna till att bokföringen uteblir och bedöma företagets framtida
          möjligheter att återuppta verksamheten eller upprätthålla sin
          långsiktiga stabilitet.
        </p>
      </div>
    ),
  },
};

triggerTexts[12] = {
  SE: {
    enum_key: 'LiquidityGeneralWarning',
    trigger_id: 12,
    trigger_type: 'DEFAULT',
    name: 'Likviditeten är otillräcklig',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har otillräcklig likviditet innebär det att företaget
          inte har tillräckliga medel för att täcka sina kortfristiga skulder
          och löpande betalningar, såsom leverantörsskulder, löner och andra
          omedelbara kostnader. Detta kan skapa allvarliga problem för bolagets
          dagliga verksamhet och kan leda till betalningsinställelse om
          likviditeten inte förbättras.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kassaflödet: Se till att företaget har en tydlig och
              realistisk prognos för sitt kassaflöde. Bedöm om bolaget har
              möjlighet att förbättra sin likviditet genom effektivare hantering
              av intäkter och kostnader.
            </p>
          </li>
          <li>
            <p>
              Undersök orsakerna till likviditetsbristen: Ta reda på varför
              bolaget har otillräcklig likviditet. Är det ett resultat av
              förlorad försäljning, förhöjda kostnader eller långsamt betalande
              kunder? Förstå roten till problemet innan du fattar beslut.
            </p>
          </li>
          <li>
            <p>
              Bedöm åtgärdsplanen: Har bolaget en plan för att förbättra
              likviditeten, t.ex. genom att effektivisera verksamheten, få in
              externa investeringar eller sälja tillgångar? Kontrollera om dessa
              åtgärder är realistiska och hållbara.
            </p>
          </li>
          <li>
            <p>
              Be om säkerheter: Om du som kreditgivare är tveksam till bolagets
              förmåga att betala tillbaka lån på grund av likviditetsproblem,
              kan det vara lämpligt att begära säkerheter för att minska risken.
            </p>
          </li>
          <li>
            <p>
              Följ upp regelbundet: Om du beviljar kredit till ett företag med
              otillräcklig likviditet, se till att följa upp regelbundet för att
              säkerställa att företaget vidtar åtgärder för att rätta till
              situationen.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt vaksam på företag med
          otillräcklig likviditet, eftersom det kan innebära en högre risk för
          betalningsinställelse och missade betalningar. Det är avgörande att
          förstå orsakerna bakom likviditetsbristen och säkerställa att
          företaget har en trovärdig plan för att förbättra sin likviditet innan
          du beviljar eller fortsätter finansiering.
        </p>
      </div>
    ),
  },
};

triggerTexts[13] = {
  SE: {
    enum_key: 'IncomingPayments',
    trigger_id: 13,
    trigger_type: 'DEFAULT',
    name: 'Förfallna kundfakturor',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har förfallna kundfakturor innebär det att företaget inte
          har fått betalt för sina sålda varor eller tjänster i enlighet med de
          överenskomna betalningsvillkoren. Förfallna kundfakturor kan indikera
          problem med kundernas betalningsförmåga eller att bolaget har
          ineffektiva rutiner för att hantera och driva in sina fordringar.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska fordringarna: Kontrollera hur många förfallna kundfakturor
              som finns och bedöm deras ålder. Om fakturorna är mycket gamla kan
              detta vara ett tecken på ineffektiv uppföljning eller allvarliga
              problem med kundens betalningsförmåga.
            </p>
          </li>
          <li>
            <p>
              Utvärdera kundrelationerna: Ta reda på om förfallna fakturor är
              ett resultat av kundens finansiella problem eller om det handlar
              om bristande rutiner för fakturering och uppföljning. Är detta ett
              tillfälligt problem eller ett återkommande mönster?
            </p>
          </li>
          <li>
            <p>
              Kontrollera uppföljning av betalningar: Se om bolaget har
              effektiva rutiner för att följa upp förfallna fakturor och vidta
              åtgärder för att driva in betalningar. Finns det ett system för
              att snabbt hantera och påminna kunder om utestående betalningar?
            </p>
          </li>
          <li>
            <p>
              Bedöm kundernas betalningsförmåga: Om förfallna kundfakturor är
              många, bedöm kundernas finansiella stabilitet och om det finns
              risk för ytterligare betalningsproblem från deras sida.
            </p>
          </li>
          <li>
            <p>
              Säkerställ likviditet: Kontrollera om bolaget har tillräcklig
              likviditet för att klara av sina egna förpliktelser även om
              kundbetalningar dröjer. Det kan vara viktigt att företaget har
              alternativa finansieringskällor eller säkerheter för att hantera
              likviditetsbristen.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på förfallna kundfakturor,
          eftersom det kan tyda på allvarliga likviditetsproblem eller
          ineffektiva rutiner för fakturering och uppföljning. Det är viktigt
          att förstå orsakerna bakom förfallna fakturor och säkerställa att
          bolaget vidtar åtgärder för att minska risken för att detta påverkar
          deras betalningsförmåga och stabilitet på lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[14] = {
  SE: {
    enum_key: 'OutgoingPayments',
    trigger_id: 14,
    trigger_type: 'DEFAULT',
    name: 'Förfallna leverantörsfakturor',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har förfallna leverantörsfakturor innebär det att
          företaget inte har betalat sina leverantörer inom den överenskomna
          tidsramen. Detta kan tyda på likviditetsproblem, en svag
          betalningsförmåga eller en ineffektiv hantering av betalningar och
          leverantörsskulder.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska leverantörsskulderna: Kontrollera hur många förfallna
              leverantörsfakturor som finns och bedöm deras ålder. Är det ett
              tillfälligt problem, eller ett återkommande mönster?
            </p>
          </li>
          <li>
            <p>
              Undersök orsakerna: Ta reda på varför leverantörsfakturorna är
              förfallna. Är det en konsekvens av likviditetsproblem eller
              ineffektiva rutiner för betalningar? Har bolaget en plan för att
              åtgärda situationen?
            </p>
          </li>
          <li>
            <p>
              Bedöm bolagets kassaflöde: Granska bolagets kassaflöde och hur det
              hanterar sina kortfristiga förpliktelser. Har bolaget tillräcklig
              likviditet för att betala sina leverantörer och upprätthålla
              verksamheten?
            </p>
          </li>
          <li>
            <p>
              Kontrollera betalningsrutiner: Se om bolaget har effektiva rutiner
              för att hantera och prioritera leverantörsbetalningar. Är det en
              brist på ordning eller ett tecken på att företaget inte är
              tillräckligt proaktivt i att hantera sina skulder?
            </p>
          </li>
          <li>
            <p>
              Säkerställ åtgärdsplan: Be bolaget förklara vilka åtgärder de
              vidtar för att hantera förfallna fakturor och förbättra sin
              likviditet. Finns det en plan för att förbättra
              betalningsdisciplinen och undvika framtida problem?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara mycket vaksam på förfallna
          leverantörsfakturor, eftersom de kan indikera allvarliga
          likviditetsproblem eller en brist på finansiell kontroll. Det är
          avgörande att förstå orsakerna bakom förfallna fakturor och att
          bolaget har en konkret plan för att rätta till situationen, annars
          finns en risk att detta påverkar deras förmåga att betala tillbaka
          sina lån och upprätthålla verksamheten på lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[15] = {
  SE: {
    enum_key: 'ShortTermLiquidity',
    trigger_id: 15,
    trigger_type: 'DEFAULT',
    name: 'Kortfristig likviditet',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte har tillräcklig likviditet för att täcka sina
          kortfristiga utgifter, innebär det att företaget inte har tillräckliga
          medel för att betala sina löpande förpliktelser som
          leverantörsskulder, löner och andra omedelbara kostnader. Detta kan
          bero på ett
        </p>
        <p>
          negativt kassaflöde, en obalanserad skuldstruktur eller ineffektiv
          hantering av likvida medel.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska likviditetsprognoser: Kontrollera om bolaget har en
              realistisk plan för att hantera den kortfristiga likviditeten. Hur
              ser den prediktiva likviditeten ut på kort och lång sikt? Finns
              det en åtgärdsplan för att förbättra likviditeten?
            </p>
          </li>
          <li>
            <p>
              Utvärdera kassaflödet: Bedöm hur bolaget hanterar sitt kassaflöde
              och om det finns potentiella lösningar för att öka inflödet av
              likvida medel, till exempel snabbare inkassering av kundfordringar
              eller förlängning av betalningstider med leverantörer.
            </p>
          </li>
          <li>
            <p>
              Undersök orsaker till likviditetsbristen: Ta reda på varför
              bolaget har otillräcklig likviditet. Är det en tillfällig
              likviditetsbrist som kan lösas med extern finansiering, eller är
              det ett tecken på mer långsiktiga problem i verksamheten?
            </p>
          </li>
          <li>
            <p>
              Be om säkerheter: Om du som kreditgivare är osäker på bolagets
              förmåga att återbetala ett lån på grund av likviditetsbrist, kan
              det vara lämpligt att be om säkerheter för att skydda din
              investering.
            </p>
          </li>
          <li>
            <p>
              Säkerställ finansieringsstrategi: Bedöm om bolaget har en strategi
              för att säkra ytterligare finansiering, såsom kortfristiga lån,
              factoring eller omstrukturering av befintliga skulder, för att
              förbättra sin likviditet.
            </p>
          </li>
          <li>
            <p>
              Följ upp regelbundet: Om du beviljar kredit till ett bolag med
              otillräcklig likviditet, se till att följa upp regelbundet för att
              säkerställa att bolaget vidtar åtgärder för att förbättra sin
              likviditet och inte hamnar i en mer akut finansiell kris.
            </p>
          </li>
        </ul>
        <p>
          När du som kreditgivare använder prediktiv likviditet för att bedöma
          ett företags likviditet, kan ett negativt eller otillräckligt resultat
          indikera en allvarlig risk för företagets kortsiktiga
          betalningsförmåga. Det är viktigt att säkerställa att bolaget har en
          tydlig plan för att förbättra sin likviditet och att du som långivare
          vidtar lämpliga åtgärder för att minimera riskerna för din
          investering.
        </p>
      </div>
    ),
  },
};

triggerTexts[16] = {
  SE: {
    enum_key: 'Tax',
    trigger_id: 16,
    trigger_type: 'DEFAULT',
    name: 'Likviditeten täcker inte skatter och avgifter',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte har tillräcklig likviditet för att täcka sina
          skatter och avgifter innebär det att företaget inte har tillräckliga
          medel för att betala sina skatteåtaganden och andra obligatoriska
          avgifter. Detta kan skapa allvarliga problem för bolaget, både ur ett
          finansiellt och ett rättsligt perspektiv.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kassaflödet: Kontrollera om bolaget har en realistisk
              prognos för att generera tillräcklig likviditet för att täcka
              skatter och avgifter inom kort. Bedöm om det finns åtgärder som
              kan vidtas för att förbättra kassaflödet snabbt, t.ex. genom att
              påskynda kundinbetalningar eller sälja tillgångar.
            </p>
          </li>
          <li>
            <p>
              Undersök orsaker till likviditetsbristen: Ta reda på varför
              bolaget inte har tillräcklig likviditet för att betala sina
              skatter och avgifter. Är det en tillfällig situation som kan lösas
              med kortfristad finansiering, eller är det ett tecken på
              långsiktiga problem med bolagets finansiella styrning?
            </p>
          </li>
          <li>
            <p>
              Bedöm åtgärdsplanen: Har bolaget en plan för att förbättra sin
              likviditet, såsom att omstrukturera skulder, få externa
              investeringar, eller förlänga betalningstider med leverantörer?
              Kontrollera om dessa åtgärder verkar realistiska och genomförbara.
              Be om säkerheter: Om du är osäker på bolagets förmåga att betala
              sina skatter och avgifter på kort sikt, kan det vara lämpligt att
              begära säkerheter som en garanti för att täcka eventuella skatte-
              eller avgiftsskulder.
            </p>
          </li>
          <li>
            <p>
              Säkerställ att bolaget har skattehantering på plats: Om bolaget
              har likviditetsproblem som påverkar skattebetalningar, är det
              viktigt att de har en robust strategi för att hantera och fördela
              skattebetalningar framöver. Be om detaljerad information om hur de
              planerar att hantera framtida skatter och avgifter.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara mycket försiktig med företag som inte har
          tillräcklig likviditet för att täcka sina skatter och avgifter. Detta
          kan vara en indikator på allvarliga finansiella problem och kan leda
          till rättsliga och operativa konsekvenser om det inte åtgärdas snabbt.
          Det är avgörande att säkerställa att bolaget har en klar och
          realistisk plan för att lösa sina likviditetsproblem och betala sina
          skatteåtaganden i tid.
        </p>
      </div>
    ),
  },
};

triggerTexts[17] = {
  SE: {
    enum_key: 'CostInterest',
    trigger_id: 17,
    trigger_type: 'DEFAULT',
    name: 'Räntekostnader',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Kostnadsräntor är ett resultat av bolagets skulder. Skulderna
          genererar räntor. Kostnadsräntor kan också vara ett resultat av
          bolagets sena betalningar till sina leverantör vilket kan indikera
          risk att den finansiella hälsan inte är optimal.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          När ett bolag redovisar kostnadsräntor finns det flera viktiga
          aspekter att ta hänsyn till för att säkerställa en korrekt och säker
          hantering av denna information. Här är några centrala punkter att
          överväga:
        </p>
        <ul>
          <li>
            <p>
              Finansiell hälsa: Fråga om betalningssvårigheter, detta då
              kostnadsräntor är ett tecken på detta!
            </p>
          </li>
          <li>
            <p>
              Överväg noggrant er borgenärsroll till bolaget. Kommer vi att bli
              utsatta för sena betalningar?
            </p>
          </li>
          <li>
            <p>
              Kan vi hjälpa aktören med bättre lån och finansiering så att
              räntan kan gå ner?
            </p>
          </li>
          <li>
            <p>
              Kan bolagets skulder re-finansieras och genom det sänka
              räntekostnaderna?
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[18] = {
  SE: {
    enum_key: 'EarningInterest',
    trigger_id: 18,
    trigger_type: 'DEFAULT',
    name: 'Ränteintäkter',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Intäktsräntor är en intäkt som aktören får genom utlånat kapital och
          material. Intäktsräntor är också ett resultat av att bolagets kunder
          betalar sent och därför ackumuleras en ränta.
        </p>
        <p>
          Intäktsräntor kan vara ett tecken på dåliga betalare som i längden
          påverkar bolagets verksamhet i stort.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          När ett bolag redovisar intäktsräntor finns det flera viktiga aspekter
          att ta hänsyn till för att säkerställa en korrekt och säker hantering
          av denna information. Här är några centrala punkter att överväga:
        </p>
        <ul>
          <li>
            <p>Vad beror sena betalningar på?</p>
          </li>
          <li>
            <p>Hur lång kredittid har kunden?</p>
          </li>
          <li>
            <p>Hur ofta följer man upp inbetalning?</p>
          </li>
          <li>
            <p>
              Kan kundens fakturor komma att innebära kundförluster på längre
              sikt?
            </p>
          </li>
          <li>
            <p>
              Skulle bolaget kunna använda sig av factoring lösning för kortare
              kredittider?
            </p>
          </li>
          <li>
            <p>Skulle kundens fakturor komma att innebära regresser?</p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[19] = {
  SE: {
    enum_key: 'VAT',
    trigger_id: 19,
    trigger_type: 'DEFAULT',
    name: 'Likviditeten täcker inte momsskuld',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte har tillräcklig likviditet för att täcka sin
          momsskuld innebär det att företaget inte har tillgång till
          tillräckliga medel för att betala sin skatt på varor och tjänster
          (moms). Detta kan leda till allvarliga konsekvenser för bolaget, både
          på kort och lång sikt.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska likviditetsprognosen: Kontrollera om bolaget har en
              realistisk plan för att förbättra sin likviditet och säkerställa
              att momsen kan betalas inom en rimlig tidsram. Finns det åtgärder
              som kan vidtas för att snabbt öka inflödet av likvida medel, till
              exempel genom att påskynda kundinbetalningar eller reducera
              kostnader?
            </p>
          </li>
          <li>
            <p>
              Undersök orsakerna till likviditetsbristen: Ta reda på varför
              bolaget inte har tillräcklig likviditet för att betala momsen. Är
              det ett tillfälligt problem som kan lösas med kortfristad
              finansiering, eller är det ett tecken på långsiktiga finansiella
              problem som måste åtgärdas?
            </p>
          </li>
          <li>
            <p>
              Be om åtgärdsplan: Be bolaget om en detaljerad åtgärdsplan för att
              förbättra sin likviditet och täcka sin momsskuld. Finns det en
              plan för att få in kapital snabbt eller för att förhandla om
              betalningarna för att undvika rättsliga problem?
            </p>
          </li>
          <li>
            <p>
              Säkerställ skattehantering och regelefterlevnad: Säkerställ att
              bolaget har ordning på sina skatte- och momsrelaterade åtaganden.
              Finns det en plan för att undvika att detta problem upprepas i
              framtiden, eller för att säkerställa att bolaget upprätthåller
              regelefterlevnad?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt försiktig när ett bolag inte har
          tillräcklig likviditet för att täcka sin momsskuld. Detta kan vara ett
          tecken på större finansiella problem, som kan påverka företagets
          långsiktiga stabilitet och dess förmåga att betala tillbaka lån. Det
          är avgörande att förstå orsakerna bakom likviditetsproblemen och att
          få en tydlig plan från företaget för att rätta till situationen innan
          ytterligare finansiering beviljas.
        </p>
      </div>
    ),
  },
};

triggerTexts[20] = {
  SE: {
    enum_key: 'TaxBalanceNegative',
    trigger_id: 20,
    trigger_type: 'DEFAULT',
    name: 'Negativt saldo på skattekonto',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Ett negativt saldo på skattekontot innebär att bolaget är skyldig
          Skatteverket pengar. Detta kan bero på obetalda skatter eller
          avgifter, exempelvis moms, arbetsgivaravgifter eller företagets
          preliminära skatt. Följande kan hända:
        </p>
        <ul>
          <li>
            <p>
              Ränta och avgifter – Om skulden inte betalas i tid kan ränta och
              eventuella påminnelseavgifter tillkomma, vilket gör skulden
              större.
            </p>
          </li>
          <li>
            <p>
              Betalningskrav och indrivning – Skatteverket kan skicka
              betalningskrav, och om skulden inte betalas kan de inleda en
              indrivningsprocess, vilket kan innebära att pengar dras direkt
              från företagets bankkonto eller att företaget får betala via andra
              metoder.
            </p>
          </li>
          <li>
            <p>
              Kreditvärdering och förtroende – Ett negativt skattekonto kan
              påverka företagets kreditvärdighet negativt, vilket gör det
              svårare att få lån eller andra former av finansiering.
            </p>
          </li>
          <li>
            <p>
              Risk för företagslicens – Om betalningar inte görs kan
              Skatteverket i allvarliga fall besluta att avregistrera företaget
              från F-skatt eller ta andra åtgärder som kan påverka företagets
              verksamhet.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Om ett bolag har ett negativt saldo på skattekontot hos Skatteverket
          är det viktigt att snabbt vidta åtgärder för att hantera situationen
          och förhindra att den förvärras. Här är några bra åtgärder att vidta
          samt saker att tänka på framåt:
        </p>
        <ul>
          <li>
            <p>
              Identifiera orsaken till förseningen: För att kunna hantera
              problemet är det viktigt att förstå varför betalningen blev
              försenad. Det kan vara på grund av ekonomiska svårigheter,
              missförstånd av skattekraven eller andra faktorer.
            </p>
          </li>
          <li>
            <p>
              Kontakta Skatteverket: Det bästa steget är att omedelbart kontakta
              Skatteverket och få förklarat situationen.
            </p>
          </li>
          <li>
            <p>
              Be om historiska transaktioner: Skatteverket är offentligt vilket
              gör att du kan begära skatteinformation. Här ser du också ifall
              bolaget är sen flertalet gånger.
            </p>
          </li>
        </ul>
        <p>
          Att hantera ett negativt saldo på skattekontot snabbt och effektivt är
          avgörande för att undvika ytterligare påföljder som ränta och
          indrivning. Genom att ta kontroll över företagets kassaflöde, skapa en
          likviditetsbuffert och förbättra rutinerna för skattebetalningar kan
          man förebygga framtida problem.
        </p>
      </div>
    ),
  },
};

triggerTexts[21] = {
  SE: {
    enum_key: 'PositiveSalesTrend',
    trigger_id: 21,
    trigger_type: 'DEFAULT',
    name: 'Stigande försäljning flera månader i rad',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har stigande försäljning flera månader i rad, innebär det
          att företaget upplever tillväxt och att efterfrågan på deras produkter
          eller tjänster ökar. Detta kan vara ett positivt tecken på företags
          framgång, men det kan också medföra risker. Ökad försäljning kan
          potentiellt indikera oegentligheter såsom bedrägeri eller
          penningtvätt, särskilt om ökningen är abrupt eller inte verkar stämma
          överens med bolagets historiska prestationer eller branschens normer.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kassaflödesprognoser: Kontrollera om bolaget har
              tillräcklig likviditet för att hantera den ökade försäljningen och
              de potentiella utgifterna som kan uppstå, t.ex. ökade lager eller
              utgifter för produktionskapacitet.
            </p>
          </li>
          <li>
            <p>
              Bedöm risken i kundfordringarna: Undersök om bolaget har effektiva
              rutiner för att hantera och följa upp sina kundfordringar. En ökad
              försäljning kan innebära högre utestående belopp, vilket kan
              påverka bolagets likviditet om kunder inte betalar i tid.
            </p>
          </li>
          <li>
            <p>
              Följ upp tillväxtstrategin: Bedöm om bolagets tillväxt är baserad
              på hållbara marknadstrender och om företaget har en långsiktig
              plan för att upprätthålla eller öka sin försäljning på ett
              hållbart sätt.
            </p>
          </li>
          <li>
            <p>
              Kontrollera kapitalbehov: Se om bolaget behöver ytterligare
              finansiering för att stötta sin tillväxt. Är de i behov av lån
              eller krediter för att täcka lagerförvärv eller investeringar i
              produktionskapacitet?
            </p>
          </li>
          <li>
            <p>
              Granska kundtransaktioner och betalningshistorik: Se till att de
              ökade försäljningsintäkterna har legitima kunder som faktiskt
              betalar. Undersök om det finns några ovanliga mönster i
              betalningsflödena eller om det finns en hög andel av kunder som
              betalar via riskfyllda kanaler som kontanter eller oförklarade
              betalningsmedel.
            </p>
          </li>
          <li>
            <p>
              Följ upp med KYC (Know Your Customer): Se till att företaget har
              genomfört tillräcklig KYC-process för att verifiera sina kunder
              och säkerställa att inga transaktioner sker med misstänkta eller
              oklara parter som kan vara involverade i penningtvätt eller
              bedrägeri.
            </p>
          </li>
          <li>
            <p>
              Använd riskbedömning för kunder och transaktioner: Implementera
              processer för att bedöma risknivån för varje kund eller
              transaktion, särskilt om dessa sker på ovanliga marknader eller om
              betalningsmetoder verkar avvika från det normala. Vid höga risker,
              överväg att noggrant granska företagets försäljningshistorik.
            </p>
          </li>
        </ul>
        <p>
          Det är viktigt att förstå hur den ökade försäljningen påverkar
          bolagets likviditet och om företaget har kapacitet att hantera
          tillväxten utan att öka risken för finansiella problem.
        </p>
        <p>
          Som kreditgivare bör du vara medveten om att stigande försäljning inte
          alltid innebär en stabil och hållbar affärsmodell. Om ökningen sker
          snabbt eller utan tydlig förklaring kan det vara ett tecken på
          potentiella risker, såsom bedrägeri eller penningtvätt. Det är viktigt
          att noggrant kontrollera alla transaktioner och säkerställa att
          bolaget har goda interna rutiner för att hantera dessa risker och
          följa relevanta regler för att upprätthålla regelefterlevnad och
          transparens.
        </p>
      </div>
    ),
  },
};

triggerTexts[22] = {
  SE: {
    enum_key: 'NegativeSalesTrend',
    trigger_id: 22,
    trigger_type: 'DEFAULT',
    name: 'Sjunkande försäljning flera månader i rad',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Xpektors algoritmer ger dig en varning när företagets omsättning
          sjunker tre månader i rad. Detta är ett tecken på att bolagets
          finansiella hälsa måste bli bättre.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          När ett bolag redovisar en sjunkande försäljning eller omsättning
          finns det flera viktiga aspekter att ta hänsyn till för att
          säkerställa en korrekt och säker hantering av denna information. Här
          är några centrala punkter att överväga:
        </p>
        <ul>
          <li>
            <p>Vad beror den sjunkande försäljningen på?</p>
          </li>
          <li>
            <p>Är det förväntat på grund av säsong?</p>
          </li>
          <li>
            <p>Kommer företaget att bryta trenden?</p>
          </li>
          <li>
            <p>Är det att förvänta sig att månader kommer att sjunka?</p>
          </li>
          <li>
            <p>Kan bolaget uppvisa avtal eller offerter?</p>
          </li>
          <li>
            <p>Skulle bolaget må bättre av ett bryggkapital?</p>
          </li>
          <li>
            <p>
              Är finansiering av tillgångar eller re-finansiering ett
              alternativ?
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[23] = {
  SE: {
    enum_key: 'RevenueVariation',
    trigger_id: 23,
    trigger_type: 'DEFAULT',
    name: 'Väsentlig omsättningsvariation',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Väsentlig omsättningsvariation betyder att ett företags intäkter
          förändras kraftigt mellan olika perioder, till exempel mellan månader
          eller år. Det kan handla om både en kraftig ökning och en stor
          minskning av omsättningen. I det fall där omsättningen varierar mer än
          30% mellan månader eller år ska man kunna ge en förklaring till detta.
        </p>
        <p>Omsättningsvariationer kan bero på olika saker, tex:</p>
        <p>
          Säsongsvariationer: Företaget kanske säljer mer under vissa delar av
          året, som vid jul eller sommar.
        </p>
        <p>
          Marknadsförändringar: Konkurrens, ändrade kundbeteenden eller nya
          produkter på marknaden kan påverka försäljningen.
        </p>
        <p>
          Interna faktorer: Företaget kan ha genomfört förändringar, till
          exempel lanserat en ny produkt, tappat en stor kund eller haft
          leveransproblem.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Att identifiera och förstå omsättningsvariationer hjälper dig att få
          en tydligare bild av företagets stabilitet och potential. Några saker
          man kan tänka på:
        </p>
        <p>
          Förstå orsaken: Ta reda på varför variationen uppstår. Är det en
          naturlig del av verksamheten, som säsongsmönster, eller beror det på
          ett problem, som minskad efterfrågan?
        </p>
        <p>
          Kassaflöde: Kontrollera om företaget har tillräckligt med likvida
          medel för att klara perioder med lägre omsättning.
        </p>
        <p>
          Prognoser: Be om framtidsprognoser och affärsplaner för att förstå hur
          företaget planerar att hantera variationerna.
        </p>
        <p>
          Riskhantering: Överväg om företaget har tillräckliga marginaler och
          strategier för att hantera plötsliga förändringar.
        </p>
      </div>
    ),
  },
};

triggerTexts[24] = {
  SE: {
    enum_key: 'OtherExternalCostsIncrease',
    trigger_id: 24,
    trigger_type: 'DEFAULT',
    name: 'Övriga externa kostnader ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har sett en ökning av övriga externa kostnader med 30%
          eller mer under en månad, innebär det att företaget har haft en
          oväntad eller betydande ökning av sina löpande kostnader. Ökningen kan
          bero på flera olika faktorer, och det är viktigt att undersöka
          orsakerna till den kraftiga ökningen för att förstå dess påverkan på
          företagets finansiella hälsa.
        </p>
        <p>
          Övriga externa kostnader kan inkludera utgifter för leverantörer,
          hyror, marknadsföring, konsulttjänster, transport, och andra externa
          tjänster som företaget behöver för att driva sin verksamhet.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till kostnadsökningen: Be företaget förklara
              varför de externa kostnaderna har ökat med så pass mycket.
            </p>
          </li>
          <li>
            <p>
              Kontrollera kassaflödesprognoser: Granska om bolaget har
              tillräcklig likviditet och kassaflöde för att hantera den ökade
              kostnadsnivån. Kan dessa ökade kostnader påverka företagets
              förmåga att betala sina kortfristiga skulder, inklusive lån och
              leverantörsskulder?
            </p>
          </li>
          <li>
            <p>
              Följ upp på resultat: Om kostnadsökningen inte matchas med en
              intäktsökning, bör du som kreditgivare vara extra uppmärksam på
              bolagets långsiktiga lönsamhet. Be om en uppföljning av bolagets
              resultat och åtgärder som vidtas för att minska eller hantera de
              externa kostnaderna.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare är det viktigt att noggrant undersöka orsakerna till
          att ett bolags externa kostnader har ökat med 30% eller mer under en
          månad. En kraftig ökning kan indikera potentiella risker för
          företagets kassaflöde, lönsamhet och långsiktiga finansiella hälsa.
          Att förstå om ökningen är en tillfällig händelse eller en varaktig
          förändring är avgörande för att bedöma bolagets förmåga att hantera
          dessa kostnader och för att avgöra om ytterligare finansiering eller
          åtgärder behövs.
        </p>
      </div>
    ),
  },
};

triggerTexts[25] = {
  SE: {
    enum_key: 'OtherExternalCostsDecrease',
    trigger_id: 25,
    trigger_type: 'DEFAULT',
    name: 'Övriga externa kostnader minskar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har sett en minskning av övriga externa kostnader med 30%
          eller mer under en månad, kan detta indikera att företaget har lyckats
          sänka sina löpande driftskostnader av någon anledning. Det kan vara
          ett tecken på effektiviseringar eller kostnadsbesparande åtgärder. Men
          det är också viktigt att undersöka varför dessa kostnader har minskat
          så kraftigt, eftersom det kan finnas både positiva och negativa
          orsaker till en sådan förändring.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till minskningen: Be företaget förklara varför
              de externa kostnaderna har minskat så kraftigt. Är det på grund av
              effektiviseringar eller nedskärningar som kan påverka verksamheten
              negativt?
            </p>
          </li>
          <li>
            <p>
              Kontrollera långsiktig hållbarhet: Bedöm om minskningen är hållbar
              utan att försämra kvaliteten på produkter eller tjänster.
            </p>
          </li>
          <li>
            <p>
              Undersök påverkan på verksamheten: Se om minskningen påverkar
              andra områden som produktion, kundtjänst eller marknadsföring.
            </p>
          </li>
          <li>
            <p>
              Bedöm framtida intäktsförmåga: Följ upp om minskningen är en
              strategi för att hantera svagare intäkter eller en långsiktig
              förbättring.
            </p>
          </li>
          <li>
            <p>
              Kontrollera finansiell rapportering: Säkerställ att minskningen
              inte beror på förändrad redovisningsmetod som kan ge ett
              missvisande resultat.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på minskningen av externa
          kostnader med 30% eller mer. Även om det kan vara ett tecken på att
          företaget har förbättrat sin kostnadseffektivitet och därmed
          förbättrat sitt kassaflöde, kan det också vara en varning om bolaget
          har gjort nedskärningar som kan påverka verksamheten negativt på lång
          sikt. Det är viktigt att få en klar förståelse för orsakerna till
          kostnadsminskningen och att bedöma hur detta kan påverka företagets
          långsiktiga tillväxt och stabilitet.
        </p>
      </div>
    ),
  },
};

triggerTexts[26] = {
  SE: {
    enum_key: 'NoInsurance',
    trigger_id: 26,
    trigger_type: 'DEFAULT',
    name: 'Företagsförsäkring saknas',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          En företagsförsäkring är ett skydd för företag mot olika typer av
          risker och oförutsedda händelser som kan påverka verksamheten.
          Försäkringen kan täcka allt från skador på egendom, ansvar vid
          rättstvister, till avbrott i verksamheten. Exakt vad som ingår beror
          på vilken typ av försäkring företaget tecknat och vilka behov det har.
        </p>
        <p>
          En företagsförsäkring är en grundläggande del av att driva ett
          ansvarsfullt och tryggt företag. Den ger inte bara ekonomiskt skydd
          utan också förtroende hos kunder, anställda och samarbetspartners.
        </p>
        <p>Avsaknad av försäkring kan innebära:</p>
        <p>
          Ekonomiska risker: Utan försäkring kan företaget tvingas betala stora
          summor ur egen ficka vid en olycka, stöld, brand eller annan skada.
        </p>
        <p>
          Förlorade affärer: Många kunder och samarbetspartners kräver att
          företaget har vissa typer av försäkringar, exempelvis
          ansvarsförsäkring. Avsaknad kan leda till att företaget förlorar
          affärsmöjligheter.
        </p>
        <p>
          Osäkerhet för anställda: Om olyckor inträffar på arbetsplatsen kan
          avsaknad av försäkring skapa oro och försämra företagets relationer
          med sina anställda.
        </p>
        <p>
          Risk för konkurs: Om en större händelse inträffar som bolaget inte kan
          hantera ekonomiskt, kan det leda till att företaget inte klarar att
          fortsätta verksamheten.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Begär försäkringsbevis: Be företaget att visa att de har en
          företagsförsäkring som matchar deras verksamhet.
        </p>
        <p>
          Utvärdera risker: Om företaget saknar försäkring kan det vara en
          varningssignal om bristande riskhantering eller ekonomisk press.
        </p>
        <p>
          Tänk på säkerhet: Utan försäkring är det större risk att företaget
          inte kan hantera oförutsedda händelser, vilket kan påverka dess
          betalningsförmåga eller långsiktiga överlevnad.
        </p>
      </div>
    ),
  },
};

triggerTexts[27] = {
  SE: {
    enum_key: 'LegalFees',
    trigger_id: 27,
    trigger_type: 'DEFAULT',
    name: 'Advokatkostnader',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Advokatkostnader uppstår när ett företag anlitar juridisk hjälp,
          exempelvis från en advokat eller jurist, för att hantera olika typer
          av rättsliga frågor. Det kan röra sig om att lösa tvister, upprätta
          avtal, hantera arbetsrättsliga frågor, eller försvara sig i
          rättsprocesser. Dessa kostnader kan vara engångsbelopp för specifika
          uppdrag eller löpande kostnader för juridisk rådgivning.
        </p>
        <p>Vad advokatkostnader kan ge indikationer på:</p>
        <p>
          Rättsliga tvister: Om ett företag har höga advokatkostnader kan det
          vara en signal på att företaget är inblandat i en rättslig konflikt,
          exempelvis med en leverantör, kund eller tidigare anställd.
        </p>
        <p>
          Expansions- eller omstrukturering: Företaget kan anlita juridisk hjälp
          för att hantera företagsförvärv, starta verksamhet i nya regioner
          eller omstrukturera företaget.
        </p>
        <p>
          Avtal eller regelefterlevnad: Advokatkostnader kan också tyda på att
          företaget arbetar med att upprätta avtal eller säkerställa att det
          följer lagar och regler i sin bransch.
        </p>
        <p>
          Akuta problem: Plötsligt uppkomna advokatkostnader kan signalera att
          företaget hanterar något akut eller oväntat, till exempel en rättslig
          konflikt eller en myndighetsutredning.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Analysera syftet: Försök att förstå varför advokatkostnaderna uppstår.
          Är de kopplade till något positivt, som expansion eller avtal, eller
          något negativt, som en rättstvist?
        </p>
        <p>
          Bedöm omfattningen: Höga eller återkommande advokatkostnader kan vara
          ett tecken på att företaget har omfattande juridiska problem, vilket
          kan påverka dess ekonomiska hälsa.
        </p>
        <p>
          Fråga efter transparens: Be företaget förklara vad advokatkostnaderna
          gäller. Det kan hjälpa dig att få en tydligare bild av deras situation
          och framtidsutsikter.
        </p>
      </div>
    ),
  },
};

triggerTexts[28] = {
  SE: {
    enum_key: 'WarehouseGrowing',
    trigger_id: 28,
    trigger_type: 'DEFAULT',
    name: 'Lager ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har sett att lagret har ökat stadigt innebär det att
          företaget har byggt upp mer varor eller material som inte har sålts
          eller använts. Detta kan tyda på att bolaget förväntar sig ökad
          efterfrågan på sina produkter eller tjänster, eller så kan det bero på
          problem med att sälja varorna i takt med den ökande produktionen. Det
          är viktigt att förstå orsakerna till ökningen för att bedöma de
          potentiella riskerna och fördelarna.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till lagerökningen: Be företaget förklara varför
              lagret har ökat stadigt. Är det på grund av förväntad
              efterfrågeökning, eller finns det problem med att sälja varorna?
            </p>
          </li>
          <li>
            <p>
              Bedöm lageromsättningshastighet: Kontrollera hur snabbt företaget
              säljer sitt lager (lageromsättningshastighet). Ett snabbt ökande
              lager utan motsvarande försäljning kan indikera ineffektivitet
              eller svag efterfrågan.
            </p>
          </li>
          <li>
            <p>
              Utvärdera kassaflödet: Ökade lager innebär att kapital binds i
              varor, vilket kan påverka kassaflödet negativt. Bedöm om företaget
              har tillräcklig likviditet för att hantera lagret, särskilt om
              försäljningen inte håller jämna steg med lagerökningen.
            </p>
          </li>
          <li>
            <p>
              Bedöm risk för lagerförluster: Om lagret består av varor som
              snabbt förlorar sitt värde eller blir föråldrade, kan detta
              innebära en risk för nedskrivningar. Kontrollera om företaget har
              rätt rutiner för att hantera föråldrat eller långsamt omsättande
              lager.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ett bolags stadiga
          lagerökning. Om ökningen beror på förväntad efterfrågan kan det vara
          ett tecken på en välplanerad tillväxtstrategi, men om lagret växer
          utan motsvarande försäljning kan det indikera kassaflödesproblem eller
          ineffektivitet. Det är viktigt att förstå orsakerna bakom
          lagerökningen och att bedöma om bolaget har kontroll över sina lager
          och sina finansieringsbehov för att undvika långsiktiga finansiella
          problem.
        </p>
      </div>
    ),
  },
};

triggerTexts[29] = {
  SE: {
    enum_key: 'WarehouseUnchanged',
    trigger_id: 29,
    trigger_type: 'DEFAULT',
    name: 'Lager oförändrat',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har ett lager som inte förändras över tid kan detta tyda
          på att företaget antingen inte har tillräcklig efterfrågan på sina
          produkter eller inte har en effektiv lagerhantering. Ett oförändrat
          lager kan också innebära att företaget inte uppdaterar sina inköp
          eller produktion för att möta marknadens behov, vilket kan påverka
          deras förmåga att reagera på förändringar i efterfrågan.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska efterfrågan och försäljning: Bedöm om lagrets oförändring
              beror på minskad efterfrågan. Har försäljningen stagnerat, och om
              så är fallet, varför?
            </p>
          </li>
          <li>
            <p>
              Undersök lagerhantering och processer: Kontrollera om företaget
              har effektiva rutiner för att uppdatera och hantera sitt lager. Är
              lageromsättningshastigheten låg? Är varorna relevanta och
              efterfrågade på marknaden?
            </p>
          </li>
          <li>
            <p>
              Utvärdera risker för föråldrat lager: Om produkterna i lagret är
              föråldrade eller inte längre efterfrågade, kan företaget behöva
              göra nedskrivningar på lagervärdet, vilket kan påverka bolagets
              finansiella ställning.
            </p>
          </li>
          <li>
            <p>
              Analysera kassaflöde och likviditet: Ett stillastående lager kan
              innebära att kapital binds utan att generera inkomst. Bedöm om
              företaget har tillräcklig likviditet för att hantera sitt lager
              utan att äventyra kassaflödet.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ett bolags oförändrade
          lager. Om lagret står stilla kan det tyda på svag efterfrågan eller
          ineffektiv lagerhantering, vilket kan påverka bolagets finansiella
          stabilitet och framtida tillväxt. Det är viktigt att noggrant
          undersöka orsakerna bakom det stillastående lagret och bedöma hur
          detta påverkar företagets kassaflöde, likviditet och långsiktiga
          affärsstrategi.
        </p>
      </div>
    ),
  },
};

triggerTexts[30] = {
  SE: {
    enum_key: 'ImmaterialAssetsIncrease',
    trigger_id: 30,
    trigger_type: 'DEFAULT',
    name: 'Immateriella tillgångar ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har sett att de immateriella tillgångarna har ökat mellan
          månader, innebär det att företaget har investerat i eller förvärvat
          immateriella tillgångar som t.ex. patent, varumärken, goodwill,
          mjukvarulicenser eller andra icke-fysiska tillgångar. Immateriella
          tillgångar kan vara värdefulla för ett företag om de bidrar till att
          skapa intäkter och långsiktig tillväxt, men de kan också innebära
          risker beroende på hur de hanteras och värderas.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till ökningen: Be företaget förklara varför de
              immateriella tillgångarna har ökat. Är det genom investeringar i
              forskning och utveckling, förvärv av varumärken eller patent,
              eller någon annan form av expansion?
            </p>
          </li>
          <li>
            <p>
              Kontrollera värderingsmetoder: Säkerställ att de immateriella
              tillgångarna är korrekt värderade. Är de baserade på realistiska
              uppskattningar av framtida intäkter eller på osäkra bedömningar?
              Har företaget genomfört några nedskrivningar på tidigare
              immateriella tillgångar?
            </p>
          </li>
          <li>
            <p>
              Utvärdera lönsamheten: Bedöm om de immateriella tillgångarna
              faktiskt kommer att skapa långsiktig lönsamhet. För exempelvis
              patent eller varumärken, finns det en tydlig plan för hur dessa
              tillgångar kommer att generera intäkter? Har företaget en strategi
              för att utnyttja dessa tillgångar på ett effektivt sätt?
            </p>
          </li>
          <li>
            <p>
              Risken för nedskrivningar: Immateriella tillgångar är ofta svåra
              att värdera och kan bli nedskrivna om de inte visar sig vara så
              lönsamma som väntat. Bedöm om bolaget har en plan för att hantera
              eventuell nedskrivning av immateriella tillgångar i framtiden.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ökningen av immateriella
          tillgångar, särskilt om dessa tillgångar representerar en stor del av
          bolagets balansräkning. Immateriella tillgångar kan vara en viktig
          tillgång om de rättfärdigas av framtida intäktsgenerering, men de
          innebär också risker om de inte är korrekt värderade eller om de inte
          lever upp till de förväntningar som har satts. Det är viktigt att
          förstå orsakerna till ökningen och bedöma hur detta kan påverka
          företagets långsiktiga lönsamhet och finansiella stabilitet.
        </p>
      </div>
    ),
  },
};

triggerTexts[31] = {
  SE: {
    enum_key: 'EquityVariation',
    trigger_id: 31,
    trigger_type: 'DEFAULT',
    name: 'Eget kapital har förändrats under månaden',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om det egna kapitalet förändras under månaden innebär det att
          företagets finansiering, som representeras av aktieägarnas kapital och
          ackumulerade vinster eller förluster, har ändrats. Förändringar i det
          egna kapitalet kan bero på flera olika faktorer, t.ex. nyemissioner,
          utdelningar, vinst eller förlust under perioden, eller nedskrivningar
          på tillgångar.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till förändringen: Be företaget förklara varför
              det egna kapitalet har förändrats. Är förändringen ett resultat av
              vinst eller förlust, eller är det kopplat till externa faktorer
              som nyemission eller utdelningar?
            </p>
          </li>
          <li>
            <p>
              Undersök nyemission eller kapitaltillskott: Om det egna kapitalet
              har ökat genom nyemission eller kapitaltillskott, bedöm hur detta
              påverkar ägarstrukturen och om det finns några nya förpliktelser
              eller risker kopplade till det nya kapitalet.
            </p>
          </li>
          <li>
            <p>
              Kontrollera utdelningar och återköp av aktier: Om bolaget har
              delat ut vinst eller återköpt aktier, bedöm om detta är hållbart
              och om det påverkar företagets framtida likviditet och förmåga att
              återinvestera i verksamheten.
            </p>
          </li>
          <li>
            <p>
              Följ upp på nedskrivningar: Om förändringen beror på
              nedskrivningar eller värderingsförändringar, undersök om dessa
              påverkar företagets framtida intäktsgenerering och om det finns
              risk för ytterligare nedskrivningar framöver.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på förändringar i det egna
          kapitalet, eftersom det kan ge värdefull information om företagets
          finansiella hälsa och framtida potential. En ökning av det egna
          kapitalet kan indikera starkare finansiell ställning och större
          säkerhet för långivare, medan en minskning kan signalera problem med
          lönsamheten, överdrivna utdelningar eller oplanerade förluster. Det är
          viktigt att förstå orsakerna bakom förändringen för att bedöma
          företagets långsiktiga stabilitet och risker.
        </p>
      </div>
    ),
  },
};

triggerTexts[32] = {
  SE: {
    enum_key: 'LongTermDebtIncrease',
    trigger_id: 32,
    trigger_type: 'DEFAULT',
    name: 'Långfristiga skulder har ökat under månaden',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Långfristiga skulder är skulder som företaget förväntas betala
          tillbaka längre fram i tiden, oftast med en löptid på mer än ett år.
          En ökning av långfristiga skulder innebär att företaget har tagit på
          sig mer långsiktig finansiering, vilket kan ske genom exempelvis:
        </p>
        <ul>
          <li>
            <p>Lån från banker eller kreditinstitut.</p>
          </li>
          <li>
            <p>Upptagande av obligationer.</p>
          </li>
          <li>
            <p>Leasingavtal för tillgångar som fastigheter eller maskiner.</p>
          </li>
        </ul>
        <p>
          Denna typ av skuld är vanligt vid investeringar i verksamheten, men
          det kan också signalera ett behov av att täcka kassaflödesproblem.
        </p>
        <p>Vad kan det indikera?</p>
        <ol>
          <li>
            <p>
              Investeringar: Företaget har kanske lånat pengar för att
              finansiera investeringar i tillgångar, som maskiner, lokaler eller
              teknologi, vilket kan stärka verksamheten långsiktigt.
            </p>
          </li>
          <li>
            <p>
              Tillväxt: Ökningen kan vara ett tecken på expansion, där företaget
              behöver kapital för att växa eller etablera sig på nya marknader.
            </p>
          </li>
          <li>
            <p>
              Likviditetsbehov: Det kan också indikera att företaget har behövt
              låna för att täcka löpande kostnader eller tidigare skulder,
              vilket kan vara en varningssignal.
            </p>
          </li>
          <li>
            <p>
              Oväntade utgifter: Ett företag kan ha ställts inför oförutsedda
              kostnader som krävt finansiering.
            </p>
          </li>
          <li>
            <p>
              Ökad räntebörda: Lånen medför räntekostnader som påverkar
              företagets resultat och kassaflöde.
            </p>
          </li>
          <li>
            <p>
              Försämrad soliditet: Om skulderna ökar snabbare än tillgångarna
              kan företagets soliditet försämras, vilket gör det mindre
              attraktivt för investerare och långivare.
            </p>
          </li>
          <li>
            <p>
              Exponering för ränterisk: Om räntan stiger kan det bli dyrare att
              betala tillbaka skulderna.
            </p>
          </li>
        </ol>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Syftet med skulden: Kontrollera varför skulden har ökat. Om det
          handlar om strategiska investeringar är det ofta positivt, medan lån
          för att täcka driftskostnader kan tyda på ekonomiska problem.
        </p>
        <p>
          Skuldsättningsgrad: Granska företagets totala skuldsättning i
          förhållande till dess egna kapital. Om skulderna är höga i förhållande
          till tillgångarna kan det indikera en hög risk.
        </p>
        <p>
          Betalningsförmåga: Kontrollera företagets kassaflöde och förmåga att
          hantera räntekostnader och amorteringar.
        </p>
      </div>
    ),
  },
};

triggerTexts[33] = {
  SE: {
    enum_key: 'PredictiveCashFlow',
    trigger_id: 33,
    trigger_type: 'DEFAULT',
    name: 'Framtida likviditet är otillräcklig',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har otillräcklig framtida likviditet innebär det att
          företaget inte har tillräckliga medel för att täcka sina förväntade
          betalningar i framtiden, vilket kan orsaka allvarliga problem för dess
          verksamhet. Trots att företaget kanske har tillräcklig likviditet för
          att täcka sina nuvarande åtaganden, kan de förväntade in- och
          utbetalningarna enligt den prediktiva likviditeten indikera ett
          kommande likviditetsunderskott. Detta kan bero på faktorer som låga
          kundinbetalningar, höga kommande utgifter eller andra
          kassaflödesproblem.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kassaflödesprognoser: Kontrollera om företaget har
              realistiska prognoser för sina framtida in- och utbetalningar. Är
              de förväntade kundinbetalningarna tillräckliga för att täcka de
              kommande utgifterna? Bedöm om företaget har identifierat
              potentiella problem och om de vidtar åtgärder för att förbättra
              kassaflödet.
            </p>
          </li>
          <li>
            <p>
              Undersök framtida betalningsförpliktelser: Bedöm om de framtida
              utbetalningarna är hanterbara. Är det några stora, förutspådda
              utgifter eller betalningar som kan ge upphov till
              likviditetsproblem? Kan företaget förlänga betalningstider eller
              förhandla om sina förpliktelser?
            </p>
          </li>
          <li>
            <p>
              Bedöm kunder och kundfordringar: Om kundinbetalningar är en stor
              del av företags kassaflöde, undersök om det finns risker för
              fördröjningar i dessa betalningar. Hur lång är den genomsnittliga
              betalningstiden? Finns det kunder som historiskt sett har varit
              sena med betalning?
            </p>
          </li>
          <li>
            <p>
              Kontrollera finansieringsalternativ: Om det finns ett förväntat
              likviditetsunderskott, bedöm om företaget har tillgång till
              externa finansieringsalternativ, såsom lån eller kreditlinjer, för
              att täcka kortfristiga likviditetsbrister.
            </p>
          </li>
          <li>
            <p>
              Be om åtgärdsplan: Om bolaget inte har tillräcklig framtida
              likviditet, be om en plan för att hantera problemet. Kommer de att
              minska sina kostnader, öka sina intäkter, förlänga betalningstider
              eller vidta andra åtgärder för att förbättra kassaflödet?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara mycket uppmärksam på ett bolag med
          otillräcklig framtida likviditet. Det kan indikera att företaget
          kommer att ha svårt att möta sina finansiella åtaganden i framtiden,
          vilket kan leda till betalningsinställelse eller andra finansiella
          problem. Det är avgörande att noggrant granska de förväntade in- och
          utbetalningarna och bedöma hur företaget planerar att hantera
          eventuella likviditetsbrister, samt om de har realistiska åtgärder för
          att säkerställa att de kan möta sina åtaganden på lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[34] = {
  SE: {
    enum_key: 'CostOfSalesIncrease',
    trigger_id: 34,
    trigger_type: 'DEFAULT',
    name: 'Inköp av varor ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag ökar sina inköp av varor innebär det att företaget köper
          in mer varulager för att antingen möta en förväntad ökning i
          efterfrågan eller för att säkra sig mot framtida prisökningar eller
          leveransproblem. En ökning av varuinköp kan också indikera att
          företaget förbereder sig för expansion eller ökad produktion.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till ökning: Be företaget förklara varför de har
              ökat sina inköp.
            </p>
          </li>
          <li>
            <p>
              Bedöm efterfrågan och försäljning: Om inköpen är relaterade till
              en förväntad efterfrågeökning, bedöm om det finns en realistisk
              prognos för att försäljningen kommer att öka i samma takt.
            </p>
          </li>
          <li>
            <p>
              Undersök kassaflöde och likviditet: Ökade inköp innebär att mer
              kapital binds i varor, vilket kan påverka bolagets likviditet.
              Bedöm om företaget har tillräckligt med likviditet för att hantera
              dessa ökade inköp och om de har tillräcklig marginal för att
              betala för varorna utan att äventyra kassaflödet.
            </p>
          </li>
          <li>
            <p>
              Kontrollera lagernivåer och lageromsättningshastighet: Ökade inköp
              kan leda till högre lager. Granska om lageromsättningen är i linje
              med branschnormer och om företaget har tillräcklig försäljning för
              att omsätta dessa varor. Ett ökande lager utan motsvarande
              försäljning kan innebära lageröverskott som binder kapital utan
              att ge avkastning.
            </p>
          </li>
          <li>
            <p>
              Risk för föråldrade eller förlorade varor: Om varorna inte säljs i
              tillräcklig takt, kan de bli föråldrade eller förlora sitt värde.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ökade inköp av varor. Om
          ökningen är kopplad till en förväntad efterfrågeökning eller för att
          säkra fördelaktiga priser kan det vara ett positivt tecken på bolagets
          tillväxt. Om inköpen inte motsvaras av en ökad försäljning kan det
          dock skapa kassaflödesproblem och leda till överlager. Det är viktigt
          att förstå orsakerna bakom ökningen och bedöma om bolaget har
          tillräcklig likviditet och kapacitet för att hantera de ökade inköpen
          utan att påverka sin finansiella stabilitet negativt.
        </p>
      </div>
    ),
  },
};

triggerTexts[35] = {
  SE: {
    enum_key: 'CostOfSalesDecrease',
    trigger_id: 35,
    trigger_type: 'DEFAULT',
    name: 'Inköp av varor minskar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag minskar sina inköp av varor innebär det att företaget
          köper in mindre lagervara än tidigare. Detta kan bero på flera olika
          orsaker och kan ha både positiva och negativa konsekvenser för bolaget
          beroende på de bakomliggande faktorerna.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till minskningen: Be företaget förklara varför
              de har minskat sina inköp.
            </p>
          </li>
          <li>
            <p>
              Bedöm efterfrågan och försäljning: Om minskade inköp beror på
              minskad efterfrågan, bedöm om detta är en tillfällig nedgång eller
              ett tecken på långsiktiga problem i marknaden. Har bolaget
              realistiska prognoser för framtida efterfrågan?
            </p>
          </li>
          <li>
            <p>
              Undersök lagerhantering och produktionsnivåer: Granska om
              minskningen av inköp är en del av en långsiktig strategi för att
              förbättra lageromsättningen och minska lagerkostnader. Har
              företaget god kontroll på sitt lager och sina inköpsnivåer?
            </p>
          </li>
          <li>
            <p>
              Bedöm likviditetsproblem: Om minskningen beror på
              likviditetsproblem eller kassaflödessvårigheter, bör du som
              kreditgivare noggrant undersöka bolagets betalningsförmåga och
              framtida finansiella situation. Det är viktigt att förstå om
              bolaget har tillräcklig likviditet för att hantera sina löpande
              kostnader utan att äventyra verksamhetens fortsatta drift.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på minskade inköp av varor,
          eftersom det kan signalera både positiva och negativa förändringar. Om
          minskningen beror på effektiv lagerhantering och minskad
          överproduktion kan det vara ett tecken på förbättrad kostnadskontroll.
          Om det däremot beror på minskad efterfrågan eller ekonomiska
          svårigheter kan det innebära problem med kassaflöde och långsiktig
          tillväxt. Det är avgörande att förstå orsakerna bakom minskningen och
          bedöma hur detta påverkar företagets finansiella stabilitet och
          förmåga att uppfylla sina förpliktelser.
        </p>
      </div>
    ),
  },
};

triggerTexts[36] = {
  SE: {
    enum_key: 'SalaryCostIncrease',
    trigger_id: 36,
    trigger_type: 'DEFAULT',
    name: 'Lön och personalkostnader ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har en ökning av lön och personalkostnader kan detta tyda
          på flera saker. Ökade personalkostnader kan vara ett resultat av fler
          anställda, löneförhöjningar, eller andra förmåner och kostnader
          relaterade till personalen. Det är viktigt att förstå varför dessa
          kostnader har ökat och hur de påverkar företagets ekonomiska situation
          och långsiktiga hållbarhet.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaken till ökningen: Förstå om ökningen i löner och
              personalkostnader är kopplad till tillväxt eller om det beror på
              ineffektivitet eller bristande kostnadskontroll.
            </p>
          </li>
          <li>
            <p>
              Analysera produktivitet: Utvärdera om ökningen i personalkostnader
              åtföljs av motsvarande ökning i intäkter eller produktivitet.
            </p>
          </li>
          <li>
            <p>
              Kontrollera långsiktig hållbarhet: Bedöm om företaget har
              tillräckliga resurser och en långsiktig plan för att hantera de
              ökade kostnaderna utan att påverka den finansiella stabiliteten.
            </p>
          </li>
          <li>
            <p>
              Följ upp kassaflöde: Se till att den ökade kostnaden inte påverkar
              företagets kassaflöde negativt, vilket kan leda till
              likviditetsproblem.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du noggrant övervaka en ökning av löner och
          personalkostnader. En sådan ökning kan vara ett tecken på
          företagsväxt, men om den inte är kopplad till ökad produktivitet eller
          intäkter, kan den skapa ekonomiska problem på lång sikt. Det är
          viktigt att förstå varför personalkostnaderna har ökat och bedöma om
          företaget har tillräcklig kassaflödeskapacitet och en hållbar plan för
          att hantera dessa ökade kostnader.
        </p>
      </div>
    ),
  },
};

triggerTexts[37] = {
  SE: {
    enum_key: 'SalaryCostDecrease',
    trigger_id: 37,
    trigger_type: 'DEFAULT',
    name: 'Lön och personalkostnader minskar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har minskat sina löner och personalkostnader innebär det
          att företaget har minskat sina utgifter för arbetskraft, vilket kan
          bero på flera olika faktorer. En minskning kan vara ett tecken på att
          företaget försöker minska sina kostnader för att förbättra
          lönsamheten, men det kan också indikera problem med
          personalomsättning, ineffektivitet eller ekonomiska svårigheter.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till minskningen: Be företaget förklara varför
              löner och personalkostnader har minskat.
            </p>
          </li>
          <li>
            <p>
              Bedöm påverkan på verksamheten: Om minskningen beror på
              personalnedskärningar, undersök om det påverkar bolagets förmåga
              att leverera sina produkter eller tjänster. Finns det risk för att
              nedskärningarna leder till minskad produktivitet eller
              kundservice?
            </p>
          </li>
          <li>
            <p>
              Utvärdera långsiktiga effekter: Se om de minskade lönerna är
              hållbara på lång sikt. Kan bolaget behålla kompetent personal
              eller locka nya talanger trots sänkta löner? Hur påverkar detta
              företagskulturen och framtida tillväxt?
            </p>
          </li>
          <li>
            <p>
              Kontrollera om nedskärningarna är hållbara: Om minskningen är
              resultatet av omstruktureringar eller åtgärder för att hantera
              likviditetsproblem, bedöm om företaget har en långsiktig plan för
              att hantera dessa förändringar utan att äventyra sin tillväxt
              eller operativa förmåga.
            </p>
          </li>
          <li>
            <p>
              Bedöm finansiell stabilitet: Om minskningen beror på ekonomiska
              svårigheter eller likviditetsproblem, undersök om företaget har en
              plan för att återställa sin finansiella hälsa och om de kan
              hantera sina åtaganden på kort och lång sikt.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på en minskning av löner och
          personalkostnader, eftersom det kan vara både ett tecken på
          effektivisering och kostnadsbesparingar, men också på potentiella
          problem som personalnedskärningar eller ekonomiska svårigheter. Det är
          viktigt att förstå orsakerna bakom minskningen och bedöma hur dessa
          förändringar påverkar företagets långsiktiga förmåga att växa, behålla
          kompetent personal och upprätthålla en stabil och effektiv verksamhet.
        </p>
      </div>
    ),
  },
};

triggerTexts[38] = {
  SE: {
    enum_key: 'DepreciationsIncrease',
    trigger_id: 38,
    trigger_type: 'DEFAULT',
    name: 'Nedskrivningar/Avskrivningar ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag ökar sina nedskrivningar eller avskrivningar innebär det
          att företaget har minskat värdet på sina tillgångar, vilket kan
          påverka både balansräkningen och resultatet. Nedskrivningar görs för
          att anpassa tillgångarnas bokförda värde till deras verkliga eller
          återvinningsbara värde, medan avskrivningar är en systematisk
          fördelning av kostnaden för anläggningstillgångar över deras
          ekonomiska livslängd.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till ökningen: Be företaget förklara varför
              nedskrivningarna eller avskrivningarna har ökat.
            </p>
          </li>
          <li>
            <p>
              Bedöm långsiktiga effekter: Undersök om ökade nedskrivningar eller
              avskrivningar har en långsiktig effekt på företagets finansiella
              position. Kan detta påverka bolagets förmåga att generera intäkter
              och långsiktig lönsamhet?
            </p>
          </li>
          <li>
            <p>
              Utvärdera värderingen av tillgångarna: Kontrollera om
              nedskrivningarna eller avskrivningarna är rimliga och om
              värderingarna av tillgångarna är realistiska.
            </p>
          </li>
          <li>
            <p>
              Bedöm om företaget kan återhämta sig: Om ökade nedskrivningar är
              resultatet av förlorade värden på tillgångar, bedöm om företaget
              har en plan för att återhämta sig eller om dessa nedskrivningar
              indikerar ett långsiktigt problem. Hur kommer detta att påverka
              företagets tillgångar och framtida verksamhet?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ökade nedskrivningar och
          avskrivningar, eftersom det kan vara ett tecken på att företaget har
          identifierat en minskning av sina tillgångars värde. Detta kan påverka
          företagets finansiella stabilitet och lönsamhet. Det är viktigt att
          förstå orsakerna till ökningen och att bedöma hur detta kan påverka
          företagets långsiktiga tillväxt, kassaflöde och förmåga att återhämta
          sig från de minskade tillgångarna.
        </p>
      </div>
    ),
  },
};

triggerTexts[39] = {
  SE: {
    enum_key: 'DepreciationsDecrease',
    trigger_id: 39,
    trigger_type: 'DEFAULT',
    name: 'Nedskrivningar/Avskrivningar minskar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har minskat sina nedskrivningar eller avskrivningar
          innebär det att företaget har justerat sina redovisade värden för
          tillgångar på ett sätt som kan indikera att dessa tillgångar har ökat
          i värde, eller att företaget har beslutat att fördela avskrivningar
          mer fördelaktigt över tillgångarnas livslängd. En minskning av
          nedskrivningar eller avskrivningar kan förbättra resultatet på kort
          sikt, men det är viktigt att undersöka orsakerna bakom förändringen.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till minskningen: Be företaget förklara varför
              nedskrivningarna eller avskrivningarna har minskat.
            </p>
          </li>
          <li>
            <p>
              Bedöm långsiktig hållbarhet: Om minskningen beror på förbättringar
              i tillgångarnas värde, bedöm om detta är hållbart och om
              tillgångarna verkligen har återhämtat sitt långsiktiga värde. Kan
              företaget förvänta sig ytterligare ökning, eller är det en
              tillfällig justering?
            </p>
          </li>
          <li>
            <p>
              Kontrollera för framtida nedskrivningar: Bedöm om det finns risk
              för att nedskrivningar kan göras i framtiden om
              marknadsförhållandena förändras.
            </p>
          </li>
          <li>
            <p>
              Utvärdera påverkan på resultatet: Minskade nedskrivningar kan ge
              ett positivt resultat på kort sikt, men bedöm om detta är en
              hållbar förbättring.
            </p>
          </li>
          <li>
            <p>
              Följ upp på förändrade tillgångsvärderingar: Om nedskrivningarna
              har minskat på grund av förändringar i värderingen av tillgångar,
              undersök om dessa värderingar är realistiska och om de har
              genomförts av externa, oberoende experter.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på minskade nedskrivningar
          eller avskrivningar, eftersom detta kan ge en positiv effekt på
          företagets resultat och finansiella hälsa på kort sikt. Det är viktigt
          att förstå om förändringen beror på verklig värdeökning av
          tillgångarna eller om det är resultatet av ändrade
          redovisningsmetoder. Minskade nedskrivningar kan signalera att
          företaget är på väg att återhämta sig, men det är också viktigt att
          noggrant bedöma om dessa förändringar är hållbara och om de riskerar
          att dölja underliggande problem som kan påverka bolagets långsiktiga
          stabilitet och lönsamhet.
        </p>
      </div>
    ),
  },
};

triggerTexts[40] = {
  SE: {
    enum_key: 'OtherFinancialCostsIncrease',
    trigger_id: 40,
    trigger_type: 'DEFAULT',
    name: 'Övriga finansiella kostnader ökar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om övriga finansiella kostnader ökar innebär det att företaget har
          högre kostnader för finansiella transaktioner, utöver vanliga
          räntekostnader på lån. Övriga finansiella kostnader kan inkludera
          avgifter för lån, valutakursförluster, transaktionskostnader eller
          kostnader för att hantera finansiella instrument som derivat eller
          andra riskhanteringsstrategier.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till ökningen: Be företaget förklara varför de
              finansiella kostnaderna har ökat.
            </p>
          </li>
          <li>
            <p>
              Bedöm företagets skuldsättning: Om ökningen beror på högre
              skuldsättning, bedöm om företaget har tillräcklig förmåga att
              hantera sina räntor och andra finansiella åtaganden.
            </p>
          </li>
          <li>
            <p>
              Analysera risken för valutaförluster: Om ökningen beror på
              valutakursförluster, bedöm om företaget har en strategi för att
              hantera dessa risker. Använder de effektiva
              riskhanteringsinstrument eller derivat för att minska dessa
              förluster?
            </p>
          </li>
          <li>
            <p>
              Utvärdera långsiktig hållbarhet: Bedöm om den ökade finansiella
              kostnaden är hållbar på lång sikt. Kan bolaget fortsätta att
              betala dessa kostnader utan att det påverkar deras lönsamhet eller
              likviditet?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ökningen av övriga
          finansiella kostnader eftersom det kan indikera högre skuldsättning,
          valutarisker eller ökad användning av riskhanteringsinstrument. Det är
          viktigt att förstå orsakerna till ökningen och bedöma om företaget har
          kontroll över sina finansiella kostnader. Om ökningen beror på
          långsiktiga eller strukturella problem, såsom hög skuldsättning eller
          ineffektiv riskhantering, kan det innebära risker för företagets
          finansiella stabilitet.
        </p>
      </div>
    ),
  },
};

triggerTexts[41] = {
  SE: {
    enum_key: 'OtherFinancialCostsDecrease',
    trigger_id: 41,
    trigger_type: 'DEFAULT',
    name: 'Övriga finansiella kostnader minskar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har minskat sina övriga finansiella kostnader innebär det
          att företaget har lyckats minska sina utgifter relaterade till
          finansiella transaktioner, utöver vanliga räntekostnader. Detta kan
          vara ett tecken på att företaget har optimerat sin kapitalstruktur,
          minskat sin skuldsättning, eller på annat sätt effektiviserat sina
          finansiella kostnader.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till minskningen: Be företaget förklara varför
              de övriga finansiella kostnaderna har minskat.
            </p>
          </li>
          <li>
            <p>
              Bedöm företagets finansieringsstruktur: Kontrollera om minskningen
              av finansiella kostnader beror på en mer hållbar och stabil
              finansieringsstruktur.
            </p>
          </li>
          <li>
            <p>
              Analysera riskhantering: Bedöm om minskningen av finansiella
              kostnader är en följd av bättre riskhantering. Om företaget har
              lyckats minska sina valutaförluster eller förbättra sina
              finansiella instrument, kan detta vara ett tecken på en mer
              proaktiv och effektiv hantering av finansiella risker.
            </p>
          </li>
          <li>
            <p>
              Utvärdera långsiktiga fördelar: Om minskningen av finansiella
              kostnader är en effekt av långsiktiga åtgärder, t.ex. minskad
              skuldsättning eller bättre kapitalstruktur, kan detta indikera att
              bolaget är på väg att bli mer finansiellt stabilt och hållbart.
              Detta kan stärka bolagets förmåga att hantera framtida åtaganden.
            </p>
          </li>
          <li>
            <p>
              Bedöm kassaflödespåverkan: En minskning av finansiella kostnader
              kan förbättra bolagets kassaflöde, vilket gör det lättare för
              företaget att hantera sina löpande betalningar. Bedöm om denna
              förbättring av kassaflödet kommer att ge bolaget mer utrymme för
              att hantera andra finansiella åtaganden eller expansion.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på minskningen av övriga
          finansiella kostnader eftersom det kan indikera att företaget har
          förbättrat sin finansiering eller riskhantering. Detta kan stärka
          bolagets finansiella stabilitet och göra det mer hållbart på lång
          sikt. Det är viktigt att förstå de bakomliggande orsakerna till
          minskningen och att bedöma om dessa förändringar är hållbara och om de
          kan förbättra företagets kassaflöde och förmåga att hantera framtida
          åtaganden.
        </p>
      </div>
    ),
  },
};

triggerTexts[42] = {
  SE: {
    enum_key: 'NegativeBankBalance',
    trigger_id: 42,
    trigger_type: 'DEFAULT',
    name: 'Negativt banksaldo',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har ett negativt banksaldo innebär det att företaget inte
          har tillräckliga likvida medel på sina bankkonton för att täcka sina
          omedelbara betalningar och förpliktelser. Detta kan vara ett tecken på
          allvarliga likviditetsproblem och kan påverka företagets förmåga att
          hantera sin dagliga drift samt uppfylla sina finansiella åtaganden.
          Ett negativt banksaldo är ofta en varningssignal om att bolaget inte
          har tillräcklig kassaflöde för att täcka sina kortsiktiga skulder.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till det negativa saldot: Be företaget förklara
              varför de har ett negativt banksaldo. Är det ett tillfälligt
              problem som kan lösas genom snabbare kundinbetalningar, eller
              finns det ett underliggande problem med kassaflödet som kan
              påverka långsiktig stabilitet?
            </p>
          </li>
          <li>
            <p>
              Bedöm kassaflödesprognoser: Granska företagets framtida
              kassaflödesprognoser för att bedöma om det finns en realistisk
              plan för att förbättra likviditeten. Kan företaget snabbt åtgärda
              likviditetsbristen, eller är det ett tecken på långsiktiga
              problem?
            </p>
          </li>
          <li>
            <p>
              Kontrollera skuldstruktur och kreditlinjer: Om bolaget har ett
              negativt saldo på bankkontot kan det vara en indikator på att de
              är beroende av externa krediter eller lån för att täcka sina
              åtaganden. Bedöm om bolaget har tillgång till ytterligare
              finansiering om det skulle behövas för att hantera
              likviditetsproblem.
            </p>
          </li>
          <li>
            <p>
              Utvärdera långsiktig hållbarhet: Bedöm om det negativa saldot är
              ett resultat av engångsproblem eller om det är ett återkommande
              mönster. Om företaget har svårt att hantera sin likviditet på lång
              sikt, kan detta vara en indikator på finansiella svårigheter.
            </p>
          </li>
          <li>
            <p>
              Följ upp på eventuella åtgärder: Be företaget beskriva vilka
              åtgärder de vidtar för att åtgärda det negativa saldot. Har de
              planerat att förkorta betalningstider, minska kostnader eller få
              in kapital genom extern finansiering?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett negativt
          banksaldo, eftersom det kan signalera allvarliga likviditetsproblem.
          Ett företag med ett negativt banksaldo har svårt att uppfylla sina
          kortsiktiga förpliktelser, vilket kan leda till betalningsinställelse
          eller konkurs om inte problemet åtgärdas snabbt. Det är viktigt att
          noggrant bedöma orsakerna bakom det negativa saldot och om företaget
          har en hållbar plan för att återställa sin likviditet och säkerställa
          att de kan uppfylla sina åtaganden på lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[43] = {
  SE: {
    enum_key: 'LateTaxPayments',
    trigger_id: 43,
    trigger_type: 'DEFAULT',
    name: 'Betalar inte skatter och avgifter i tid',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte betalar sina skatter och avgifter i tid innebär det
          att företaget inte uppfyller sina legala skyldigheter gentemot
          Skatteverket eller andra myndigheter. Detta kan tyda på allvarliga
          finansiella problem, särskilt om det handlar om återkommande försenade
          betalningar, och kan leda till böter, påminnelseavgifter eller
          rättsliga åtgärder.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till förseningen: Be företaget förklara varför
              skatterna och avgifterna inte betalats i tid.
            </p>
          </li>
          <li>
            <p>
              Bedöm kassaflödet och likviditeten: Bedöm om företagets kassaflöde
              är tillräckligt för att täcka både löpande driftskostnader och
              skatter/avgifter. Om bolaget inte kan betala sina skatter och
              avgifter kan det även ha problem med att hantera andra finansiella
              förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Undersök företagets betalningshistorik: Kontrollera om det här är
              ett enstaka fall eller ett återkommande problem. Om försenade
              betalningar är vanligt kan det tyda på strukturella problem med
              företagets ekonomi och betalningsförmåga.
            </p>
          </li>
          <li>
            <p>
              Utvärdera eventuell förlikning med Skatteverket: Se om företaget
              har gjort några arrangemang med Skatteverket, som att skjuta upp
              betalningar eller förhandla om en avbetalningsplan. Detta kan ge
              en indikation på hur de planerar att hantera sina åtaganden
              framöver.
            </p>
          </li>
          <li>
            <p>
              Kontrollera företagets långsiktiga stabilitet: Om skatte- och
              avgiftsbetalningarna inte sker i tid kan detta leda till
              allvarliga rättsliga konsekvenser, som böter, ränta eller
              betalningsinställelse. Bedöm om företaget har tillräcklig
              långsiktig finansiell stabilitet för att hantera dessa
              konsekvenser.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett bolag som inte
          betalar sina skatter och avgifter i tid. Detta kan vara ett tecken på
          allvarliga likviditetsproblem eller dålig ekonomisk styrning, och kan
          leda till ytterligare rättsliga och finansiella konsekvenser för
          företaget. Det är viktigt att noggrant förstå orsakerna bakom
          förseningen och bedöma om företaget har en hållbar plan för att lösa
          sina likviditetsproblem och uppfylla sina skatteåtaganden i framtiden.
        </p>
      </div>
    ),
  },
};

triggerTexts[44] = {
  SE: {
    enum_key: 'AveragePaymentCustomers45',
    trigger_id: 44,
    trigger_type: 'DEFAULT',
    name: 'Kunder betalar inte i tid',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolags kunder inte betalar sina fakturor i tid innebär det att
          företaget inte får in pengar i enlighet med sina förväntningar, vilket
          kan skapa likviditetsproblem. Detta binder kapital i kundfordringar
          och gör det svårt för företaget att täcka sina egna kortfristiga
          förpliktelser, såsom leverantörsskulder, löner och andra
          driftskostnader. Om försenade betalningar är ett återkommande problem
          kan det också indikera att kunderna har betalningssvårigheter, vilket
          kan påverka bolagets framtida intäkter och stabilitet.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kundernas betalningshistorik: Bedöm om den genomsnittliga
              betaltiden är en engångshändelse eller ett återkommande problem.
              Är detta ett tecken på att kunderna har ekonomiska problem?
            </p>
          </li>
          <li>
            <p>
              Utvärdera kundrelationer och betalningsrutiner: Se om företaget
              har effektiva rutiner för att följa upp på sena betalningar och om
              de har en tydlig policy för att hantera kreditrisker.
            </p>
          </li>
          <li>
            <p>
              Bedöm påverkan på likviditet: Kontrollera om den långsamma
              betalningstiden påverkar företagets likviditet negativt. Kan
              företaget hantera sina omedelbara förpliktelser med de nuvarande
              betalningsvillkoren?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ett bolag vars kunder inte
          betalar i tid, eftersom detta kan indikera likviditetsproblem och
          påverka företagets förmåga att hantera sina egna förpliktelser. Det är
          viktigt att förstå orsakerna till de sena betalningarna och bedöma om
          företaget har effektiva rutiner för att hantera kundfordringar och
          säkerställa att de kan upprätthålla sin likviditet och stabilitet på
          lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[45] = {
  SE: {
    enum_key: 'ForbiddenLoans',
    trigger_id: 45,
    trigger_type: 'DEFAULT',
    name: 'Förbjudna lån',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Ett förbjudet lån är när ett företag lånar ut pengar till sina ägare,
          styrelseledamöter, vd eller deras närstående, vilket inte är tillåtet
          enligt svensk lag. Syftet med regeln är att skydda företagets
          tillgångar och minska risken för att företagets ekonomi utnyttjas för
          privata ändamål.
        </p>
        <p>Exempel på förbjudna lån:</p>
        <ul>
          <li>
            <p>
              En företagsägare lånar pengar från bolaget för att köpa en privat
              bil.
            </p>
          </li>
          <li>
            <p>
              En styrelseledamot tar ut ett privat lån från bolaget för att
              betala sina skulder.
            </p>
          </li>
        </ul>
        <p>Undantag:</p>
        <p>Det finns vissa undantag där lån är tillåtna, exempelvis:</p>
        <ul>
          <li>
            <p>
              Förskott på löner eller andra ersättningar, så länge beloppet är
              rimligt och en del av löpande verksamhet.
            </p>
          </li>
          <li>
            <p>
              Lån mellan företag i samma koncern, under vissa förutsättningar.
            </p>
          </li>
        </ul>
        <p>Vad kan hända om ett förbjudet lån uppstår?</p>
        <ol>
          <li>
            <p>
              Återbetalningskrav: Låntagaren måste betala tillbaka beloppet till
              bolaget.
            </p>
          </li>
          <li>
            <p>
              Skattetillägg: Beloppet kan betraktas som lön eller utdelning,
              vilket innebär att både bolaget och låntagaren kan behöva betala
              skatt och avgifter.
            </p>
          </li>
          <li>
            <p>
              Rättsliga konsekvenser: Ett förbjudet lån kan leda till böter
              eller i allvarliga fall fängelsestraff för styrelseledamöter eller
              företagsägare.
            </p>
          </li>
        </ol>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>Att tänka på när det gäller förbjudna lån:</p>
        <p>
          Undvik privata transaktioner via bolaget: Se till att hålla privata
          och företagsrelaterade kostnader separata.
        </p>
        <p>
          Kontrollera regelverket: Säkerställ att alla lån följer
          aktiebolagslagen.
        </p>
        <p>
          Ta hjälp av experter: Om ett förbjudet lån redan uppstått, är det
          viktigt att snabbt konsultera en revisor eller redovisningskonsult för
          att rätta till situationen och minimera konsekvenserna.
        </p>
      </div>
    ),
  },
};

triggerTexts[46] = {
  SE: {
    enum_key: 'HandlesCash',
    trigger_id: 46,
    trigger_type: 'DEFAULT',
    name: 'Kontanthantering',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Ett bolag som handlar med eller använder kontanter innebär risk.
          Därför ger Xpektor Anledningen till kontanthantering kan vara många
          men i dagens handel mellan bolag eller individer bör inte stora
          mängder kontanter hanteras.
        </p>
        <p>
          Kontanter är en viktig faktor för kriminella nätverk varför ursprunget
          till kontanterna noga bör följas upp.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          När ett bolag hanterar kontanter finns det flera viktiga aspekter att
          ta hänsyn till för att säkerställa en korrekt och säker hantering av
          dessa medel. Här är några centrala punkter att överväga:
        </p>
        <ul>
          <li>
            <p>
              Intern kontroll: Säkerställ att bolaget har etablerat strikta
              interna kontrollrutiner för att säkerställa att
              kontanttransaktioner övervakas och dokumenteras noggrant. Det kan
              innefatta att ha separata personer ansvariga för olika delar av
              kontanthanteringen, regelbunden avstämning av kassaböcker och
              kontroller för att förebygga och upptäcka bedrägeri eller stöld.
            </p>
          </li>
          <li>
            <p>
              Redovisning och rapportering: Se till att bolagets alla
              kontanttransaktioner bokförs korrekt och registreras i företagets
              bokföringssystem. Säkerställ spårbarhet.
            </p>
          </li>
          <li>
            <p>
              Förebyggande åtgärder mot bedrägeri: Se till att bolaget har
              implementerat kontroller för att förhindra och upptäcka bedrägeri
              och oegentligheter i kontanthanteringen.
            </p>
          </li>
          <li>
            <p>
              Begär kontantintyg underskrivet av revisor: Genom ett underskrivet
              kontantintyg säkerställer du bolagets hantering.
            </p>
          </li>
          <li>
            <p>
              Fråga om bankningsrutiner och senaste insättningskvittot: Genom
              att ställa dessa kontrollfrågor får du möjlighet att förstå om
              kontanterna behandlas rutinmässigt, eller om kontanterna
              existerar.
            </p>
          </li>
          <li>
            <p>
              Ställ frågor: Saknas bankningskvitton? Ställ frågan om varför.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[47] = {
  SE: {
    enum_key: 'FearedBadDebt',
    trigger_id: 47,
    trigger_type: 'DEFAULT',
    name: 'Befarade kreditförluster',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Konstaterad kundförlust kan avse den faktiska förlusten av en kund
          eller intäkter från en kund som redan har inträffat och har
          dokumenterats eller identifierats av företaget.
        </p>
        <p>
          Det kan handla om förlust av en specifik kund, vanligtvis genom avslut
          av affärsrelationen eller uteblivna betalningar, och denna förlust har
          bekräftats eller dokumenterats av företaget.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          När ett bolag redovisar kundförluster finns det flera viktiga aspekter
          att ta hänsyn till för att säkerställa en korrekt och säker hantering
          av denna information. Här är några centrala punkter att överväga:
        </p>
        <ul>
          <li>
            <p>
              Kundförluster innebär risk för borgenärer eller dennes
              leverantörer.
            </p>
          </li>
          <li>
            <p>
              Viktigt att ställa frågan om det finns andra fakturor som kan
              tänkas vara kundförluster?
            </p>
          </li>
          <li>
            <p>
              Finns det anledning att tro att fler kundförluster kommer att
              påverka bolagets ställning?
            </p>
          </li>
          <li>
            <p>Beror kundförlusterna på en eller flera kunder?</p>
          </li>
          <li>
            <p>Jämför omsättningen med kundförlusten.</p>
          </li>
          <li>
            <p>
              Ligger det kundfakturor kvar i företaget som inte är bokförda som
              kundförlust?
            </p>
          </li>
          <li>
            <p>
              Är kundförlusterna frekventa varje månad bör man utreda om
              kundförlusterna är ett verktyg.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[48] = {
  SE: {
    enum_key: 'CalculatedResultAfterTax',
    trigger_id: 48,
    trigger_type: 'DEFAULT',
    name: 'Resultat efter skatt sviktar eller är otillräckligt',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har otillräckligt resultat efter att ha räknat med
          skatten innebär det att företaget har gjort en förlust efter att alla
          kostnader, inklusive skatter och icke-avdragsgilla kostnader, har
          beaktats. Ett negativt resultat kan vara ett tecken på att företaget
          har problem med lönsamheten, vilket kan påverka dess förmåga att
          betala sina skulder och andra finansiella åtaganden. I det här fallet
          har man även beaktat de skatter som följer av bolagets
          icke-avdragsgilla kostnader, vilket kan göra att förlusten är större
          än om dessa kostnader var avdragsgilla.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsakerna till förlusten: Be företaget förklara varför de
              har ett negativt resultat. Är det minskade intäkter, ökade
              kostnader eller icke-avdragsgilla kostnader?
            </p>
          </li>
          <li>
            <p>
              Bedöm kassaflöde och likviditet: Kontrollera om företaget har
              tillräcklig likviditet för att täcka sina kortsiktiga
              förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Undersök icke-avdragsgilla kostnader: Bedöm om dessa kostnader är
              en engångshändelse eller ett återkommande problem.
            </p>
          </li>
          <li>
            <p>
              Utvärdera långsiktig hållbarhet: Bedöm om förlusten indikerar
              strukturella problem som kan påverka företagets långsiktiga
              stabilitet.
            </p>
          </li>
          <li>
            <p>
              Följ upp med åtgärder för att förbättra lönsamheten: Be om en plan
              för att återställa lönsamheten, t.ex. genom kostnadsbesparingar
              eller nya intäktsströmmar.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett bolag som har
          ett negativt resultat efter att ha räknat med skatten, särskilt om det
          beror på icke-avdragsgilla kostnader eller långsiktiga förluster.
          Detta kan indikera underliggande finansiella problem som kan påverka
          bolagets förmåga att betala tillbaka sina skulder och andra åtaganden.
          Det är viktigt att noggrant förstå orsakerna till förlusten och bedöma
          om företaget har en realistisk plan för att hantera sina problem och
          återställa sin lönsamhet på lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[49] = {
  SE: {
    enum_key: 'CapitalToConsume',
    trigger_id: 49,
    trigger_type: 'DEFAULT',
    name: 'Eget kapital förbrukat',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Förbrukat eget kapital inträffar när ett företag förlorar mer pengar
          än det tjänar eller använder upp mer av ägarnas investerade kapital än
          vad som har genererats genom företagsverksamheten.
        </p>
        <p>
          Det är ett tecken på ekonomisk svaghet och kan leda till allvarliga
          konsekvenser, inklusive konkurs.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ol>
          <li>
            <p>
              Öka försäljningen och intäkterna: Företaget kan försöka öka sin
              försäljning genom marknadsföringsinsatser, produktförbättringar
              eller expansion till nya marknader. Genom att öka intäkterna kan
              företaget förbättra sin lönsamhet och återuppbygga sitt eget
              kapital.
            </p>
          </li>
          <li>
            <p>
              Kostnadsminskning: Identifiera och minska onödiga kostnader och
              ineffektiviteter inom verksamheten. Det kan innebära att
              rationalisera processer, förhandla om bättre avtal med
              leverantörer eller minska personalstyrkan om det är nödvändigt.
            </p>
          </li>
          <li>
            <p>
              Kapitalanskaffning: Företaget kan söka extern finansiering genom
              att låna pengar från banker eller investerare, eller genom att
              utfärda nya aktier för att öka det egna kapitalet.
            </p>
          </li>
          <li>
            <p>
              Förbättra lönsamheten: Utvärdera och förbättra företagets
              affärsmodell, prissättningsstrategi och produktmix för att öka
              lönsamheten. Det kan innebära att fokusera på mer lönsamma
              produktsegment eller att diversifiera verksamheten för att minska
              risken.
            </p>
          </li>
          <li>
            <p>
              Strategiska samarbeten eller partnerskap: Genom att ingå
              samarbeten eller partnerskap med andra företag kan man dra nytta
              av synergier och öka sin konkurrenskraft på marknaden.
            </p>
          </li>
        </ol>
        <p>
          Genom att implementera dessa åtgärder kan företaget arbeta mot att
          återställa sitt eget kapital och förbättra sin finansiella hälsa på
          lång sikt.
        </p>
      </div>
    ),
  },
};

triggerTexts[50] = {
  SE: {
    enum_key: 'SalesWithoutFTax',
    trigger_id: 50,
    trigger_type: 'DEFAULT',
    name: 'Försäljning utan F-skatt',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag bedriver försäljning utan att inneha F-skatt innebär det
          att företaget inte är registrerat för F-skatt hos Skatteverket, vilket
          innebär att de inte får fakturera sina kunder korrekt med moms och
          redovisa skatter på sina intäkter. Detta är ett tecken på att
          företaget inte följer de regler och förpliktelser som gäller för
          företagare i Sverige. I vissa fall kan det även indikera på
          oegentligheter som skatteundandragande, bedrägeri eller penningtvätt.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska företagets registreringsstatus: Kontrollera om företaget
              är registrerat för F-skatt och om de följer Skatteverkets regler
              för moms och skatter. Är det ett administrativt problem eller en
              medveten strategi för att undvika skatter?
            </p>
          </li>
          <li>
            <p>
              Undersök orsaker till utebliven F-skatt: Be företaget förklara
              varför de inte har F-skatt. Är det på grund av oavsiktliga
              administrativa misstag eller är det en medveten handling för att
              undvika skatt?
            </p>
          </li>
          <li>
            <p>
              Bedöm risker för olaglig verksamhet: Om bolaget medvetet undviker
              att registrera sig för F-skatt kan det indikera risker för
              skatteundandragande, bedrägeri eller penningtvätt. Detta innebär
              att företaget kan vara involverat i olagliga aktiviteter som kan
              medföra rättsliga konsekvenser och ekonomiska risker för
              långivare.
            </p>
          </li>
          <li>
            <p>
              Kontrollera fakturering och moms: Ett företag utan F-skatt kan
              inte fakturera korrekt eller redovisa moms, vilket kan skapa
              skatteproblem och böter.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara mycket försiktig med ett bolag som
          bedriver försäljning utan att inneha F-skatt. Detta kan indikera att
          företaget inte följer lagstadgade krav, och i vissa fall kan det vara
          ett tecken på skatteundandragande, bedrägeri eller penningtvätt. Det
          är avgörande att förstå orsakerna bakom att företaget inte har F-skatt
          och att noggrant bedöma de rättsliga och finansiella riskerna innan du
          beviljar kredit.
        </p>
      </div>
    ),
  },
};

triggerTexts[51] = {
  SE: {
    enum_key: 'SalesWithoutVatRegistration',
    trigger_id: 51,
    trigger_type: 'DEFAULT',
    name: 'Ej momsregistrerad men redovisar försäljning',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte är momsregistrerat men ändå redovisar försäljning,
          betyder det att företaget inte är registrerat hos Skatteverket för att
          ta ut och redovisa moms på sina varor eller tjänster. Momsregistrering
          är ett krav för företag som har en viss omsättning och bedriver
          momspliktig verksamhet.
        </p>
        <p>
          Om ett bolag inte är momsregistrerat men ändå redovisar försäljning
          med moms kan det orsaka flera problem, inklusive felaktig bokföring,
          olaglig momsdebitering och rättsliga påföljder. Det är viktigt att
          kontrollera om företaget är skyldig att vara momsregistrerat och rätta
          eventuella felaktigheter i fakturering och bokföring. Företaget bör
          också kontakta Skatteverket för att få hjälp med att rätta till
          eventuella misstag och säkerställa att de följer de rätta reglerna.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Kontrollera om bolaget behöver momsregistreras, rätta faktureringen
          och bokföringen, samt eventuellt återbetala felaktig moms till
          kunderna. Det är viktigt att följa Skatteverkets regler och rådgöra
          med dem för att rätta eventuella misstag och säkerställa korrekt
          momsredovisning.
        </p>
      </div>
    ),
  },
};

triggerTexts[52] = {
  SE: {
    enum_key: 'SalaryCostsWithoutEmployerRegistration',
    trigger_id: 52,
    trigger_type: 'DEFAULT',
    name: 'Ej registrerad som arbetsgivare men redovisar lönekostnader',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte är registrerat som arbetsgivare men redovisar
          lönekostnader, innebär det att företaget inte följer de lagstadgade
          krav som ställs på arbetsgivare. Detta kan leda till flera problem,
          bland annat att arbetsgivaravgifter inte betalas in korrekt, att
          företagets löneutbetalningar inte rapporteras på rätt sätt till
          Skatteverket, samt att anställda inte får de rätta sociala förmånerna
          som exempelvis pension, sjukförsäkring och arbetslöshetsförsäkring.
        </p>
        <p>
          För kreditgivare är det viktigt att förstå risken för ytterligare
          ekonomiska och juridiska problem som kan uppstå om ett bolag inte
          följer arbetsgivarreglerna, eftersom det kan påverka
          återbetalningsförmågan och företagets långsiktiga stabilitet.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ol>
          <li>
            <p>
              Begär att bolaget rättar till situationen: Be bolaget registrera
              sig som arbetsgivare hos Skatteverket och börja redovisa
              lönekostnader korrekt.
            </p>
          </li>
          <li>
            <p>
              Granska bolagets historik: Kontrollera om det handlar om ett
              engångsproblem eller om det finns större interna rutiner att rätta
              till.
            </p>
          </li>
          <li>
            <p>
              Analysera likviditet och betalningsförmåga: Granska kassaflöde och
              betalningsförmåga för att säkerställa att bolaget har resurser att
              betala av sina skulder.
            </p>
          </li>
          <li>
            <p>
              Be om säkerhet: Om risk finns, överväg att kräva garantier eller
              säkerheter för att minska risken.
            </p>
          </li>
          <li>
            <p>
              Föreslå rådgivning: Rekommendera att bolaget söker hjälp från en
              revisor eller skatterådgivare för att säkerställa efterlevnad.
            </p>
          </li>
          <li>
            <p>
              Avvakta beslut: Om tvivel finns på bolagets stabilitet, överväg
              att vänta med lånebeslut tills problemen är åtgärdade.
            </p>
          </li>
        </ol>
      </div>
    ),
  },
};

triggerTexts[53] = {
  SE: {
    enum_key: 'NoFTax',
    trigger_id: 53,
    trigger_type: 'DEFAULT',
    name: 'Ej registrerad för F-skatt',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          När ett bolag inte är registrerat för F-skatt innebär det att bolaget
          inte är godkänt att själv betala in skatter och sociala avgifter på
          sina inkomster. F-skatt är en förutsättning för att ett företag ska
          kunna bedriva affärsverksamhet på egen hand och sköta sina
          skatteåtaganden. Om ett bolag inte är registrerat för F-skatt, innebär
          det att det inte får fakturera för sina tjänster eller varor på ett
          korrekt sätt och kan inte redovisa och betala in skatt och avgifter
          som krävs enligt lag.
        </p>
        <p>Att tänka på:</p>
        <ol>
          <li>
            <p>
              Risk för oreglerade skatteåtaganden: Om bolaget inte har F-skatt,
              kan det finnas risk för att de inte betalar in rätt skatt och
              sociala avgifter, vilket kan leda till ekonomiska problem, böter
              eller krav från Skatteverket.
            </p>
          </li>
          <li>
            <p>
              Inget skydd för företagsägaren: Om bolaget inte är F-skattskyldigt
              kan ägaren vara personligt ansvarig för de skatter och avgifter
              som företaget skulle ha betalat. Detta kan påverka deras
              personliga ekonomi och låneförmåga.
            </p>
          </li>
          <li>
            <p>
              Problem med affärsrelationer: Många kunder och leverantörer kräver
              att företag är F-skattregistrerade för att ingå affärsrelationer.
              Om bolaget inte är registrerat kan det förlora affärer eller få
              problem att upprätthålla relationer.
            </p>
          </li>
          <li>
            <p>
              Betalningsförmåga: Om bolaget inte kan fakturera korrekt och får
              problem med skatteinbetalningar, kan deras likviditet och
              betalningsförmåga bli lidande, vilket gör att bolaget blir en
              högre risk för en långivare.
            </p>
          </li>
        </ol>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Be om en förklaring från bolaget om varför F-skatt saknas och om det
          finns planer på att åtgärda detta.
        </p>
        <p>
          Granska bolagets betalningshistorik och eventuella obetalda skatter
          eller avgifter.
        </p>
        <p>
          Överväg att ställa krav på att bolaget registrerar sig för F-skatt
          innan ett lån beviljas.
        </p>
        <p>
          Följ upp regelbundet för att säkerställa att bolaget åtgärdat sin
          registrering och efterlever skatteregler.
        </p>
      </div>
    ),
  },
};

triggerTexts[55] = {
  SE: {
    enum_key: 'NotPayingTaxes',
    trigger_id: 55,
    trigger_type: 'DEFAULT',
    name: 'Uppvisar momsskuld men ingen betalning',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag uppvisar en momsskuld i bokföringen men inte har gjort
          någon betalning till Skatteverket, kan detta tyda på att företaget har
          problem med att hantera sina skattemässiga förpliktelser. En obetald
          momsskuld kan indikera att företaget inte har tillräcklig likviditet
          för att betala sina skatter, vilket kan leda till böter,
          påminnelseavgifter och andra rättsliga konsekvenser. Detta kan också
          vara ett tecken på oegentligheter såsom skatteundandragande, bedrägeri
          eller penningtvätt, där företaget medvetet undviker att betala sina
          skatter.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till obetald moms: Be företaget förklara varför
              momsen inte har betalats. Är det ett kassaflödesproblem eller
              medvetet undvikande av skatt?
            </p>
          </li>
          <li>
            <p>
              Bedöm likviditet: Kontrollera om företaget har tillräckliga medel
              för att betala sina skatter och andra förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Följ upp betalningsplan: Har företaget en plan för att betala sina
              skatter och undvika ytterligare förseningsavgifter?
            </p>
          </li>
          <li>
            <p>
              Bedöm risk för bedrägeri/penningtvätt: Om betalningarna inte görs
              i tid utan god förklaring, kan det indikera skatteundandragande
              eller penningtvätt.
            </p>
          </li>
          <li>
            <p>
              Utvärdera återkommande problem: Är detta en engångshändelse eller
              ett återkommande problem för företaget?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett bolag som har
          en obetald momsskuld. Detta kan indikera allvarliga
          likviditetsproblem, bristande ekonomisk styrning eller, i värsta fall,
          skatteundandragande, bedrägeri eller penningtvätt. Det är viktigt att
          noggrant förstå orsakerna till den obetalda momsen och bedöma om
          företaget har tillräckliga resurser och en plan för att hantera sina
          skatteåtaganden framöver. Obetalda skatter kan leda till rättsliga och
          ekonomiska konsekvenser som kan påverka bolagets finansiella
          stabilitet och kan även öka risken för bedrägliga aktiviteter.
        </p>
      </div>
    ),
  },
};

triggerTexts[56] = {
  SE: {
    enum_key: 'BoardChanges',
    trigger_id: 56,
    trigger_type: 'DEFAULT',
    name: 'Ändring i styrelse',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          När det sker en ändring i styrelsen i ett bolag innebär det att en
          eller flera personer som har haft ansvar för företagets beslut och
          strategi har ersatts eller tillkommit i styrelsen. Styrelsen är den
          grupp som ansvarar för att fatta viktiga beslut om bolagets verksamhet
          och ekonomi. Om det sker förändringar kan det påverka företagets
          ledarskap, styrning och framtida riktning.
        </p>
        <p>Att tänka på:</p>
        <ol>
          <li>
            <p>
              Oklart ledarskap och beslut: En förändring i styrelsen kan skapa
              osäkerhet om vem som fattar besluten och vilken strategi bolaget
              kommer att följa framöver. Detta kan innebära en risk, särskilt om
              de nya styrelsemedlemmarna inte har erfarenhet eller kunskap om
              bolagets verksamhet.
            </p>
          </li>
          <li>
            <p>
              Påverkan på bolagets strategi: Om förändringarna i styrelsen beror
              på interna problem eller oenighet kan detta indikera att bolaget
              inte är stabilt eller att det finns problem i ledningen som kan
              påverka långsiktig tillväxt och lönsamhet.
            </p>
          </li>
          <li>
            <p>
              Risk för finansiell osäkerhet: Om den nya styrelsen inte har en
              tydlig och stabil strategi kan det påverka bolagets finansiella
              stabilitet och långsiktiga betalningsförmåga, vilket ökar risken
              för kreditgivaren.
            </p>
          </li>
          <li>
            <p>
              Fråga om eventuella interna problem: Om styrelsebytena sker mitt i
              en period av ekonomiska svårigheter eller förluster, kan det vara
              ett tecken på interna problem som behöver undersökas närmare. Det
              kan vara bra att ställa frågor om varför förändringen skedde och
              om den är relaterad till ekonomiska utmaningar.
            </p>
          </li>
        </ol>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Undersök orsaken bakom styrelsebytet och om det finns några tecken på
          interna problem.
        </p>
        <p>
          Granska de nya styrelsemedlemmarnas erfarenheter och kompetens för att
          bedöma deras förmåga att leda bolaget framåt.
        </p>
        <p>
          Följ upp om de nya styrelsemedlemmarna har tydliga planer för bolagets
          framtid och om deras strategi verkar hållbar.
        </p>
        <p>
          Utvärdera om förändringen kan påverka bolagets finansiella stabilitet
          och långsiktiga betalningsförmåga.
        </p>
        <p>
          Ha en öppen dialog med bolaget för att få en bättre förståelse för
          eventuella förändringar och deras påverkan på verksamheten.
        </p>
      </div>
    ),
  },
};

triggerTexts[57] = {
  SE: {
    enum_key: 'Bankruptcy',
    trigger_id: 57,
    trigger_type: 'DEFAULT',
    name: 'Konkurser',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          När ett bolag är i konkurs betyder det att företaget inte kan betala
          sina skulder och att det finns ett behov av att lösa företagets
          finansiella problem genom en rättslig process. Konkurs innebär att
          bolagets tillgångar säljs för att täcka så mycket av skulderna som
          möjligt, och bolaget kommer oftast att upplösas efter att alla
          tillgångar har fördelats mellan borgenärerna (de som bolaget är
          skyldig pengar). Konkursen kan vara en följd av långvariga ekonomiska
          problem, likviditetsbrist eller andra faktorer som har lett till att
          bolaget inte längre kan fortsätta sin verksamhet.
        </p>
        <p>Att tänka på:</p>
        <p>
          Betalningsförmåga: När ett bolag är i konkurs, innebär det att
          företaget inte längre har förmåga att betala sina skulder. Detta är en
          allvarlig signal om att bolaget inte kan upprätthålla sin ekonomiska
          stabilitet, vilket innebär att risken för kreditgivaren är mycket hög.
        </p>
        <p>
          Borgensansvar: Om bolaget har varit en låntagare och nu är i konkurs,
          kan kreditgivaren behöva överväga om det finns några personliga
          garantier eller borgensåtaganden som kan täcka skulderna. I många fall
          kan de personer som har garanterat bolagets lån hållas ansvariga för
          att betala tillbaka pengarna.
        </p>
        <p>
          Osäkerhet om återbetalning: Vid konkurs får långivare, inklusive
          kreditgivare, endast en del av sina utestående belopp återbetalda,
          beroende på hur mycket pengar som finns kvar efter försäljningen av
          bolagets tillgångar. Det finns ingen garanti för att alla pengar
          återbetalas, och en stor del kan förloras.
        </p>
        <p>
          Tydlig indikation på bolagets finansiella hälsa: Konkurs är ett tecken
          på att bolaget inte har kunnat hantera sina finansiella åtaganden. Det
          kan bero på en rad faktorer, som dålig likviditet, förluster eller
          ineffektiva affärsmodeller, vilket gör att kreditgivaren bör vara
          mycket försiktig innan de beviljar nya lån eller kredit.
        </p>
        <p>
          Konkursförvaltare: När ett bolag går i konkurs utses en
          konkursförvaltare som ansvarar för att sälja bolagets tillgångar och
          fördela pengarna till borgenärerna. Konkursförvaltaren kommer att
          hantera denna process och se till att de mest rättvisa åtgärderna
          vidtas för alla borgenärer.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Var mycket försiktig med att bevilja nya krediter till ett bolag som
          är i konkurs.
        </p>
        <p>
          Utvärdera de juridiska åtgärder som kan vidtas för att hantera
          konkursen och förstå att återbetalning av lån kan vara osäker.
        </p>
        <p>
          Om det finns borgensansvar, undersök om personliga garantier kan
          användas för att täcka delar av de utestående skulderna.
        </p>
        <p>
          Om bolaget är på väg in i konkurs, överväg att få tillbaka lånade
          pengar så snabbt som möjligt genom att vidta rättsliga åtgärder innan
          bolaget upplöses.
        </p>
        <p>
          Förstå att konkurs ofta betyder att det finns stora risker för
          långivaren, och att nya kreditbeslut måste göras med stor försiktighet
          och efter noggrant övervägande.
        </p>
      </div>
    ),
  },
};

triggerTexts[58] = {
  SE: {
    enum_key: 'NotPayingSocialCosts',
    trigger_id: 58,
    trigger_type: 'DEFAULT',
    name: 'Sociala kostnader redovisas inte',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte redovisar sociala avgifter innebär det att företaget
          inte fullgör sina skyldigheter gentemot Skatteverket, vilket kan leda
          till allvarliga konsekvenser. Sociala avgifter, som exempelvis
          arbetsgivaravgifter och andra sociala bidrag, är en viktig del av
          företagets skattepliktiga åtaganden. Om dessa inte redovisas korrekt
          kan det tyda på oegentligheter, bristande ekonomisk styrning eller i
          värsta fall försök att undvika skattebetalningar.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till utebliven redovisning: Be företaget förklara
              varför de inte har redovisat sociala avgifter. Är det ett
              administrativt misstag eller ett resultat av likviditetsproblem?
            </p>
          </li>
          <li>
            <p>
              Bedöm likviditeten: Kontrollera om företaget har tillräcklig
              likviditet för att betala sina sociala avgifter och andra
              förpliktelser. Om likviditetsproblem föreligger, kan det vara ett
              tecken på underliggande ekonomiska svårigheter.
            </p>
          </li>
          <li>
            <p>
              Undersök om detta är ett återkommande problem: Bedöm om det är en
              engångshändelse eller ett återkommande problem. Upprepade
              misslyckanden med att redovisa sociala avgifter kan tyda på
              djupare problem inom företaget.
            </p>
          </li>
          <li>
            <p>
              Bedöm risken för skatteundandragande: Om bolaget medvetet undviker
              att redovisa sociala avgifter kan detta indikera
              skatteundandragande, vilket kan medföra rättsliga och finansiella
              konsekvenser för bolaget.
            </p>
          </li>
          <li>
            <p>
              Följ upp på eventuella rättsliga åtgärder: Kontrollera om
              Skatteverket har vidtagit några åtgärder mot företaget, t.ex.
              böter eller andra rättsliga konsekvenser, för att säkerställa att
              företaget inte står inför ytterligare ekonomiska risker.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara mycket uppmärksam på ett bolag som inte
          redovisar sociala avgifter. Detta kan indikera bristande ekonomisk
          styrning, likviditetsproblem eller, i värsta fall, skatteundandragande
          och bedrägeri. Det är viktigt att förstå orsakerna till att sociala
          avgifter inte har redovisats och bedöma de potentiella riskerna för
          bolaget. Misslyckande att redovisa sociala avgifter kan medföra
          rättsliga och ekonomiska konsekvenser som kan påverka företagets
          förmåga att upprätthålla sina åtaganden och långsiktiga stabilitet.
        </p>
      </div>
    ),
  },
};

triggerTexts[59] = {
  SE: {
    enum_key: '=---ENUM-KEY-NOT-FOUND-IN-SERVER---=',
    trigger_id: 59,
    trigger_type: 'DEFAULT',
    name: '30 dagar sedan bokföring',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte har bokfört några transaktioner på mer än 30 dagar
          kan detta vara ett tecken på allvarliga problem med företagets interna
          ekonomiska processer eller att verksamheten inte rullar som förväntat.
          En lång period utan bokföring kan indikera bristande ekonomisk
          kontroll, försämrad likviditet eller att företaget inte bedrivit någon
          verksamhet under denna tid. En annan möjlig förklaring är att
          företaget avsiktligt undviker bokföring för att dölja ett dåligt
          resultat och ge ett bättre intryck när de söker finansiering eller
          lån.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till utebliven bokföring: Be företaget förklara
              varför bokföring uteblir. Är det ett kassaflödesproblem eller
              medveten undvikelse för att dölja dåliga resultat inför
              låneansökan?
            </p>
          </li>
          <li>
            <p>
              Bedöm likviditet: Kontrollera om företaget har tillräcklig
              likviditet för att täcka sina kortsiktiga förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Undersök verksamhetens status: Bedöm om företaget fortfarande är
              aktivt eller om verksamheten har pausats.
            </p>
          </li>
          <li>
            <p>
              Följ upp interna rutiner: Kontrollera om företaget har ordning på
              sina bokföringsrutiner och resurser för att hålla bokföringen
              uppdaterad.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam om ett bolag inte har
          bokfört något på mer än 30 dagar. Detta kan vara ett tecken på
          likviditetsproblem, bristande ekonomisk styrning eller att företaget
          inte längre bedriver någon verksamhet. Det kan även vara ett tecken på
          att företaget medvetet försöker dölja ett dåligt resultat för att ge
          ett bättre intryck inför en låneansökan. Det är avgörande att förstå
          orsakerna till att bokföringen uteblir och bedöma företagets framtida
          möjligheter att återuppta verksamheten eller upprätthålla sin
          långsiktiga stabilitet.
        </p>
      </div>
    ),
  },
};

triggerTexts[60] = {
  SE: {
    enum_key: 'WeakEquity',
    trigger_id: 60,
    trigger_type: 'DEFAULT',
    name: 'Svagt eget kapital',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har ett svagt eget kapital innebär det att företaget har
          en låg andel eget kapital i förhållande till sina skulder. Detta kan
          innebära att bolaget har svårt att tåla ekonomiska påfrestningar eller
          förluster utan att riskera konkurs. Ett svagt eget kapital kan också
          indikera att företaget är starkt beroende av extern finansiering,
          vilket ökar risken för långivare.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till svagt eget kapital: Be företaget förklara
              varför det egna kapitalet är svagt. Är det resultatet av förluster
              eller hög skuldsättning?
            </p>
          </li>
          <li>
            <p>
              Bedöm lönsamheten: Utvärdera om företaget har en hållbar
              affärsmodell och om de har möjlighet att generera vinst på lång
              sikt.
            </p>
          </li>
          <li>
            <p>
              Utvärdera skuldsättningen: Kontrollera om företaget är starkt
              beroende av extern finansiering och om de kan hantera sina
              skuldåtaganden.
            </p>
          </li>
          <li>
            <p>
              Följ upp på framtida kapitalbehov: Bedöm om företaget behöver nytt
              kapital för att stärka sitt eget kapital och om de har en plan för
              att öka det i framtiden.
            </p>
          </li>
          <li>
            <p>
              Bedöm risker för betalningsförmåga: Ett svagt eget kapital kan
              påverka företagets förmåga att hantera ekonomiska svårigheter.
              Bedöm om företaget kan hantera en nedgång i intäkter eller
              oväntade kostnader.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara försiktig med ett bolag som har svagt
          eget kapital, eftersom det kan tyda på långsiktiga finansiella
          problem. Det är viktigt att noggrant förstå orsakerna bakom det svaga
          egna kapitalet och bedöma om företaget har förmåga att förbättra sin
          finansiella ställning och hantera sina långsiktiga åtaganden.
        </p>
      </div>
    ),
  },
};

triggerTexts[61] = {
  SE: {
    enum_key: 'NonDeductibleExpenseTax',
    trigger_id: 61,
    trigger_type: 'DEFAULT',
    name: 'Ta hänsyn till skatt på ej avdragsgilla kostnader',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Ej avdragsgilla kostnader är utgifter som inte får dras av i
          företagets skattemässiga resultat, exempelvis böter, representation
          över vissa belopp, eller privata utgifter.
        </p>
        <p>
          Dessa kostnader ökar det resultat som beskattas, vilket innebär att
          företaget betalar skatt på dessa belopp trots att de inte minskat den
          faktiska vinsten. Skatten på ej avdragsgilla kostnader beräknas som
          företagets skattesats multiplicerat med de ej avdragsgilla beloppen.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Då skatten som Xpektor räknar ut är ett resultat av kostnaden
          multiplicerat med bolagsskatten 20,6% kan du räkna ut hur stora ej
          avdragsgilla kostnaderna är.
        </p>
        <p>
          Exempel: om Xpektor visar 20 600 kr i skatt uppgår de ej avdragsgilla
          kostnader till ca 100 000 kr, detta är att betrakta som stora eller
          små summor i förhållande till bolagets storlek.
        </p>
        <p>Ställ följande frågor för att förstå om kostnaderna är legitima:</p>
        <p>Avser de ej avdragsgilla kostnader?</p>
        <p>Transaktioner som har med middagar och resor att göra?</p>
        <p>Räntor på försenade inbetalningar till skatteverket?</p>
        <p>
          Är det kostnadsförda lånefordringar som de inte kommer få betalt för?
        </p>
        <p>Exempel på ej avdragsgilla kostnader</p>
        <ol>
          <li>
            <p>
              <strong>Böter och viten</strong> – Exempelvis parkeringsböter
              eller andra myndighetsavgifter.
            </p>
          </li>
          <li>
            <p>
              <strong>Representation över avdragsgilla gränser</strong> – Endast
              en del av utgifterna för representation, som mat och dryck, är
              avdragsgilla (för närvarande max 300 kr/person).
            </p>
          </li>
          <li>
            <p>
              <strong>Gåvor</strong> – De flesta gåvor till kunder är inte
              avdragsgilla, förutom enklare reklamgåvor under 300 kr.
            </p>
          </li>
          <li>
            <p>
              <strong>Privata utgifter</strong> – Exempelvis kostnader som
              gäller personlig konsumtion och inte företagets verksamhet.
            </p>
          </li>
          <li>
            <p>
              <strong>Skatter och avgifter</strong> – Inkomstskatter och privata
              skatter är inte avdragsgilla.
            </p>
          </li>
        </ol>
      </div>
    ),
  },
};

triggerTexts[62] = {
  SE: {
    enum_key: 'AveragePaymentCustomers30',
    trigger_id: 62,
    trigger_type: 'DEFAULT',
    name: 'Kunder har en genomsnittlig betaltid på över 30 dagar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har kunder med en genomsnittlig betaltid på 30 dagar
          efter förfallodatum innebär det att kunderna ofta betalar sina
          fakturor senare än det avtalade förfallodatumet. Detta kan skapa
          likviditetsproblem för företaget eftersom det binder kapital som inte
          kan användas för att täcka omedelbara förpliktelser, såsom löner,
          leverantörsskulder eller andra driftkostnader.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kundernas betalningshistorik: Bedöm om den genomsnittliga
              betaltiden är en engångshändelse eller ett återkommande problem.
              Är detta ett tecken på att kunderna har ekonomiska problem?
            </p>
          </li>
          <li>
            <p>
              Utvärdera kundrelationer och betalningsrutiner: Se om företaget
              har effektiva rutiner för att följa upp på sena betalningar och om
              de har en tydlig policy för att hantera kreditrisker.
            </p>
          </li>
          <li>
            <p>
              Bedöm påverkan på likviditet: Kontrollera om den långsamma
              betalningstiden påverkar företagets likviditet negativt. Kan
              företaget hantera sina omedelbara förpliktelser med de nuvarande
              betalningsvillkoren?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ett bolags genomsnittliga
          betaltid på 30 dagar efter förfallodatum, eftersom långsam betalning
          kan indikera likviditetsproblem och påverka företagets förmåga att
          hantera sina kortsiktiga förpliktelser. Det är viktigt att förstå
          orsakerna bakom den långsamma betalningen och bedöma om företaget har
          effektiva rutiner för att hantera kreditrisker och säkerställa
          tillräcklig likviditet för att täcka sina åtaganden.
        </p>
      </div>
    ),
  },
};

triggerTexts[63] = {
  SE: {
    enum_key: 'LargeTaxSums',
    trigger_id: 63,
    trigger_type: 'DEFAULT',
    name: 'Stora summor på skattekonto',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Att ha ett överskott på skattekontot är generellt sett inte en dålig
          sak, eftersom det innebär att bolaget har extra pengar tillgängliga
          för att täcka framtida skatteskulder eller för att begära
          återbetalning från skattemyndigheten.
        </p>
        <p>
          Är överskottet stort i förhållande till bolagets verksamhet bör man
          ställa frågor om överskottet.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Identifiera orsaken till överskottet: Är det återbetalningar från
              Skatteverket eller egna insättningar?
            </p>
          </li>
          <li>
            <p>
              Stora överskott på skattekontot är ej vanligt förekommande då man
              vanligtvis vill kunna använda pengarna i bolagets verksamhet.
            </p>
          </li>
          <li>
            <p>Se till att vara säker på överskottets ursprung.</p>
          </li>
          <li>
            <p>
              Ta reda på om skatteverket betalat ut tidigare överskott till
              bolaget eller till ett annat konto.
            </p>
          </li>
          <li>
            <p>
              Kontakta Skatteverket: Det bästa steget är att omedelbart kontakta
              Skatteverket och få förklarat situationen.
            </p>
          </li>
          <li>
            <p>
              Be om historiska transaktioner: Skatteverket är offentligt vilket
              gör att du kan begära skatteinformation
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[64] = {
  SE: {
    enum_key: 'Deferment',
    trigger_id: 64,
    trigger_type: 'DEFAULT',
    name: 'Anstånd hos Skatteverket',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Skatteanstånd är en åtgärd som tillåter en skattebetalare att
          senarelägga betalningen av sina skatter till en senare tidpunkt än den
          ursprungliga förfallodagen. Detta kan vara till nytta för personer
          eller företag som temporärt har begränsade likvida medel eller som
          upplever tillfälliga ekonomiska svårigheter.
        </p>
        <p>
          Anstånd för ett företag nämns ofta i sammanhang med coronapandemin där
          företag fick ansöka om anstånd på grund av den ekonomiska situationen
        </p>
        <p>
          Tillfälligt anstånd med betalning innebär att betalningen kan skjutas
          upp i maximalt ett år från beslutsdatumet. Anstånd kunde tidigare
          sökas för maximalt tolv perioder för månadsredovisning, fyra för de
          som redovisar per kvartal och två perioder för de som redovisar moms
          på årsbasis. I samband med att anståndet upphör finns det möjlighet
          att ansöka om förlängning av anståndet först i ytterligare ett år och
          därefter är det möjligt att ansöka om förlängt anstånd i kombination
          med en avbetalningsplan i maximalt ytterligare tre år.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>När skall anståndet betalas?</p>
          </li>
          <li>
            <p>Finns det täckning för att betala anståndet?</p>
          </li>
          <li>
            <p>
              Kan betalningen av anståndet påverka bolagets ställning så pass
              mycket att bolaget kan behöva extra lån eller krediter?
            </p>
          </li>
          <li>
            <p>Vilka kortfristiga/långfristiga risker medför anståndet?</p>
          </li>
          <li>
            <p>
              Går det att refinansiera anståndet med ytterligare lån på längre
              tid?
            </p>
          </li>
          <li>
            <p>
              Var noga med riskbedömning om bolagets ställning i övrigt inte
              klarar återbetalning av anståndet.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[65] = {
  SE: {
    enum_key: 'NegativeCashFlow',
    trigger_id: 65,
    trigger_type: 'DEFAULT',
    name: 'Låg kassalikviditet',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag har en kassalikviditet på mindre än 100 % innebär det att
          företaget inte har tillräckligt med likvida medel för att täcka sina
          kortfristiga skulder. Kassalikviditet är ett nyckeltal som mäter
          bolagets förmåga att betala sina omedelbara förpliktelser utan att
          behöva sälja långsiktiga tillgångar. Ett resultat under 100% kan tyda
          på likviditetsproblem, vilket kan göra det svårt för bolaget att
          hantera plötsliga betalningskrav eller oväntade utgifter.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Bedöm likviditetssituationen: Kontrollera företagets kassaflöde
              och hur väl det kan hantera sina kortsiktiga skulder. Ett
              kassalikviditet under 100% kan vara ett tecken på att företaget
              inte har tillräckligt med kontanter för att möta sina åtaganden på
              kort sikt.
            </p>
          </li>
          <li>
            <p>
              Granska skuldsättningen: Bedöm företagets skuldsättning och vilken
              typ av skulder det har. Är de kortfristiga skulderna hanterbara,
              eller utgör de en risk för bolaget?
            </p>
          </li>
          <li>
            <p>
              Undersök finansieringsalternativ: Följ upp på företagets strategi
              för att hantera likviditeten. Finns det planer på att öka
              kontantreserver eller refinansiera kortfristiga skulder för att
              förbättra den ekonomiska situationen?
            </p>
          </li>
          <li>
            <p>
              Analysera tillgångsstruktur: Kontrollera om bolaget har tillgångar
              som enkelt kan omvandlas till likvida medel vid behov. Är de i
              stånd att snabbt sälja eller belåna tillgångar för att täcka
              likviditetsbehov?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett bolag med
          kassalikviditet under 100%, eftersom det kan indikera att företaget
          har svårt att täcka sina kortsiktiga åtaganden. Det är viktigt att
          förstå orsakerna bakom den låga likviditeten och bedöma om företaget
          har en plan för att hantera dessa risker. Det kan vara nödvändigt att
          överväga andra finansiella faktorer för att avgöra om bolaget har
          tillräcklig stabilitet för att kunna möta sina kortfristiga
          förpliktelser.
        </p>
      </div>
    ),
  },
};

triggerTexts[66] = {
  SE: {
    enum_key: 'NoVatRegistration',
    trigger_id: 66,
    trigger_type: 'DEFAULT',
    name: 'Ej momsregistrerad',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte är momsregistrerat innebär det att företaget inte
          kan lägga på moms på sina försäljningspriser eller dra av ingående
          moms på inköp. Detta kan begränsa företagets affärsmöjligheter,
          särskilt om de säljer till momsregistrerade företag som förväntar sig
          att kunna dra av moms. Det kan också innebära att företaget inte
          följer de skatteregler som gäller i landet, vilket kan skapa rättsliga
          och finansiella risker.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till utebliven momsregistrering: Be företaget
              förklara varför de inte är momsregistrerade. Är det för att deras
              omsättning är under gränsen, eller är det ett resultat av
              bristande administrativa rutiner eller medvetet undvikande av
              skatt?
            </p>
          </li>
          <li>
            <p>
              Bedöm affärsmodellen: Om företaget inte är momsregistrerat men
              säljer till andra momsregistrerade företag, kan det bli ett hinder
              för deras affärsverksamhet. Bedöm om det finns risk att företaget
              förlorar kunder på grund av denna brist.
            </p>
          </li>
          <li>
            <p>
              Utvärdera skattehantering: Kontrollera om företaget följer andra
              skattekrav och om de är medvetna om sina förpliktelser. Bedöm om
              detta kan leda till framtida problem med Skatteverket.
            </p>
          </li>
          <li>
            <p>
              Följ upp på framtida momsregistrering: Om företaget har potential
              att växa och nå momsregistreringsgränsen, bör du följa upp om de
              har planer på att registrera sig för moms framöver.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på ett bolag som inte är
          momsregistrerat, eftersom det kan påverka företagets förmåga att
          bedriva affärsverksamhet på ett effektivt sätt, särskilt om de säljer
          till andra momsregistrerade företag. Det kan också indikera bristande
          förståelse för skatteregler eller medvetet skatteundandragande, vilket
          kan skapa rättsliga och finansiella risker. Det är viktigt att förstå
          orsakerna till den uteblivna momsregistreringen och bedöma de
          potentiella riskerna för långivare.
        </p>
      </div>
    ),
  },
};

triggerTexts[68] = {
  SE: {
    enum_key: 'NoAccountantAndNoReservation',
    trigger_id: 68,
    trigger_type: 'DEFAULT',
    name: 'Bolaget har inte revisor och saknar revisorsförbehåll',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          När ett bolag som enligt lag eller avtal bör ha en revisor inte har en
          sådan, eller om revisorns roll inte är säkerställd genom ett
          revisorsförbehåll, kan det tyda på bristande efterlevnad av företagets
          skyldigheter eller potentiella problem med bolagets interna
          kontrollsystem.
        </p>
        <p>
          När ett bolag saknar en revisor innebär det att det inte finns någon
          extern granskning av företagets räkenskaper. Detta kan skapa osäkerhet
          kring bolagets ekonomiska hälsa och pålitligheten i de finansiella
          rapporter de lämnar. Om bolaget bör ha en revisor men inte har en, kan
          det vara ett tecken på att de inte följer lagstadgade krav, vilket
          ökar risken för eventuella ekonomiska problem eller manipulation av
          siffrorna.
        </p>
        <p>Att tänka på:</p>
        <p>
          Osäkerhet kring bolagets finansiella rapportering: Utan en revisor
          finns det ingen oberoende granskning av företagets bokföring och
          ekonomiska rapporter. Detta kan innebära en risk att de finansiella
          uppgifterna inte är korrekta eller fullständiga, vilket gör det svårt
          att bedöma bolagets verkliga ekonomiska ställning.
        </p>
        <p>
          Risk för oegentligheter: Om ett bolag inte har en revisor kan det
          finnas en större risk för ekonomiska oegentligheter eller
          manipulationer av bokföringen. Revisorn fungerar som en
          säkerhetskontroll för att förhindra bedrägeri eller felaktig
          redovisning.
        </p>
        <p>
          Bristande efterlevnad av regler: Att inte ha en revisor när man är
          skyldig att ha en enligt lag eller bolagsavtal kan tyda på att
          företaget inte följer de regler som gäller för bolagsstyrning. Detta
          kan vara ett varningstecken för potentiella problem med företagets
          ledning eller att de inte uppfyller sina skyldigheter.
        </p>
        <p>
          Svårigheter att bedöma långsiktig hållbarhet: För en kreditgivare
          innebär det en ökad risk att låna ut pengar till ett bolag som inte
          har en revisor. Utan en oberoende granskning blir det svårare att göra
          en korrekt bedömning av bolagets ekonomiska stabilitet och långsiktiga
          hållbarhet.
        </p>
        <p>
          Revisorsförbehåll: Om bolaget saknar revisorsförbehåll innebär det att
          ingen särskild klausul har inkluderats för att säkerställa revisorns
          rättigheter och ansvar. Detta kan tyda på bristande strukturell
          organisation inom bolaget och kan öka risken för ekonomiska problem.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Granska bolagets efterlevnad: Kontrollera om bolaget borde ha en
          revisor enligt lag och om de faktiskt saknar en. Om så är fallet, kan
          det vara en indikator på potentiella interna problem.
        </p>
        <p>
          Följ upp med företaget: Om bolaget inte har en revisor, fråga varför
          och undersök om de har andra system för att säkerställa korrekt
          redovisning och ekonomisk transparens.
        </p>
        <p>
          Värdera risken noggrant: Eftersom det saknas extern granskning kan det
          vara svårt att bedöma bolagets finansiella situation. Var extra
          försiktig med att bevilja lån eller kredit utan att ha en tydlig bild
          av bolagets ekonomiska hälsa.
        </p>
        <p>
          Sök alternativ säkerhet eller garantier: Om bolaget inte har en
          revisor, kan det vara en god idé att kräva ytterligare säkerheter
          eller garantier för att minska risken i det potentiella lånet.
        </p>
      </div>
    ),
  },
};

triggerTexts[69] = {
  SE: {
    enum_key: 'IncomeWithoutCosts',
    trigger_id: 69,
    trigger_type: 'DEFAULT',
    name: 'Intäkter men inga kostnader',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företag redovisar intäkter men inga kostnader kan det verka
          ovanligt, eftersom de flesta verksamheter har utgifter för att driva
          sin verksamhet, såsom löner, hyror eller materialkostnader. Ett sådant
          upplägg kan tyda på något av följande:
        </p>
        <p>Möjliga orsaker:</p>
        <ol>
          <li>
            <p>
              Nybildat bolag: Bolaget kan vara i en tidig fas där intäkter har
              börjat komma in men kostnader ännu inte redovisats.
            </p>
          </li>
          <li>
            <p>
              Felaktig bokföring: Kostnader kan ha missats eller inte bokförts
              korrekt, vilket ger en missvisande bild av bolagets ekonomi.
            </p>
          </li>
          <li>
            <p>
              Speciell affärsmodell: Bolaget kanske säljer tjänster där
              kostnader är minimala, till exempel konsultverksamhet där endast
              ägarens arbete genererar intäkter.
            </p>
          </li>
          <li>
            <p>
              Oetiska eller olagliga aktiviteter: Om intäkter saknar motsvarande
              kostnader kan det signalera svartarbete, skatteundandragande eller
              annan otillåten verksamhet.
            </p>
          </li>
        </ol>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>Att kolla upp:</p>
        <p>
          Granska bokföringen: Se till att kostnader har bokförts korrekt. Om
          inga kostnader finns, undersök varför.
        </p>
        <p>
          Analysera affärsmodellen: Förstå hur bolaget genererar intäkter och
          varför kostnader saknas. Är det en rimlig förklaring baserat på
          verksamhetens karaktär?
        </p>
        <p>
          Utreda risker: Om bolaget redovisar intäkter utan kostnader kan detta
          innebära risker för skatteproblem eller bristande transparens, vilket
          kan påverka samarbeten eller långivning.
        </p>
        <p>Konkreta tips:</p>
        <p>
          Be om detaljerad dokumentation, såsom kundfakturor och eventuella
          avtal, för att säkerställa att intäkterna är legitima och matchar
          bolagets verksamhet.
        </p>
        <p>Fråga om bolagets kostnadsstruktur och undersök om den är rimlig.</p>
        <p>
          Var vaksam på bolagets regelefterlevnad. Ett företag som inte
          redovisar kostnader korrekt kan indikera bristande ekonomisk kontroll
          eller risk för oetiskt beteende.
        </p>
      </div>
    ),
  },
};

triggerTexts[70] = {
  SE: {
    enum_key: 'EquityIncrease',
    trigger_id: 70,
    trigger_type: 'DEFAULT',
    name: 'Eget kapital har ökat under månaden',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolags egna kapital har ökat under månaden innebär det att
          företaget har fått ett större nettovärde genom antingen ökade vinster,
          kapitaltillskott från ägarna eller omvärdering av tillgångar. En
          ökning av det egna kapitalet kan vara ett tecken på förbättrad
          finansiell hälsa och stabilitet, men det är viktigt att förstå
          orsakerna bakom ökningen.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till ökningen: Be företaget förklara varför det
              egna kapitalet har ökat. Är det på grund av ökade vinster,
              kapitaltillskott eller omvärdering av tillgångar?
            </p>
          </li>
          <li>
            <p>
              Bedöm hållbarheten: Bedöm om ökningen är hållbar på lång sikt. Är
              den baserad på engångshändelser, eller är det ett tecken på en
              långsiktig förbättring av bolagets ekonomiska ställning?
            </p>
          </li>
          <li>
            <p>
              Kontrollera kapitaltillskott: Om ökningen beror på ett
              kapitaltillskott från ägarna, bedöm om detta innebär ökad
              finansiell stabilitet för företaget. Finns det några villkor
              kopplade till tillskottet som kan påverka bolagets framtida
              beslutsfattande?
            </p>
          </li>
          <li>
            <p>
              Utvärdera omvärdering av tillgångar: Om ökningen beror på en
              omvärdering av tillgångar, undersök om detta är realistiskt och
              hållbart. Är de nya värderingarna grundade på objektiva kriterier
              och marknadsdata?
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara uppmärksam på en ökning av det egna
          kapitalet, då detta kan indikera förbättrad finansiell stabilitet och
          styrka. Det är viktigt att förstå orsakerna bakom ökningen och bedöma
          om det är en hållbar förbättring som kan bidra till långsiktig
          finansiell styrka. Om ökningen beror på kapitaltillskott eller
          omvärdering av tillgångar, bör du också noga bedöma om dessa
          förändringar är realistiska och långsiktigt hållbara.
        </p>
      </div>
    ),
  },
};

triggerTexts[71] = {
  SE: {
    enum_key: 'EquityDecrease',
    trigger_id: 71,
    trigger_type: 'DEFAULT',
    name: 'Eget kapital har minskat under månaden',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Eget kapital är skillnaden mellan företagets tillgångar och skulder
          och representerar ägarnas andel i företaget. Om eget kapital minskar
          under en månad betyder det att företagets tillgångar har minskat i
          förhållande till dess skulder, vilket kan bero på flera orsaker:
        </p>
        <ol>
          <li>
            <p>
              Negativt resultat: Företaget har gått med förlust under perioden,
              där kostnaderna har överstigit intäkterna.
            </p>
          </li>
          <li>
            <p>
              Utdelning: Ägarna kan ha tagit ut medel från företaget i form av
              utdelning, vilket minskar det egna kapitalet.
            </p>
          </li>
          <li>
            <p>
              Orealiserade förluster: Värdet på företagets tillgångar kan ha
              minskat, exempelvis vid nedskrivning av inventarier eller andra
              tillgångar.
            </p>
          </li>
          <li>
            <p>
              Felaktig bokföring: En minskning av eget kapital kan bero på
              misstag i bokföringen, som felaktig hantering av kostnader eller
              intäkter.
            </p>
          </li>
        </ol>
        <p>Vad kan det indikera?</p>
        <ol>
          <li>
            <p>
              Driftproblem: Om minskningen beror på förluster, kan det vara ett
              tecken på att företaget har svårt att täcka sina kostnader eller
              att intäkterna sjunker.
            </p>
          </li>
          <li>
            <p>
              Engångskostnader: Minskningen kan bero på tillfälliga kostnader,
              som större investeringar eller extraordinära utgifter.
            </p>
          </li>
          <li>
            <p>
              Svag finansiell position: Ett minskande eget kapital över tid kan
              signalera att företaget håller på att urholka sin ekonomiska
              stabilitet.
            </p>
          </li>
          <li>
            <p>
              Kontrollbalansräkning: Om eget kapital minskar för mycket kan
              företaget närma sig en situation där kontrollbalansräkning krävs
              enligt lagen. Detta gäller om det egna kapitalet understiger
              hälften av det registrerade aktiekapitalet.
            </p>
          </li>
          <li>
            <p>
              Försämrat förtroende: Minskande eget kapital kan påverka hur
              långivare, investerare och andra intressenter ser på företaget.
            </p>
          </li>
          <li>
            <p>
              Minskad handlingsfrihet: Lågt eget kapital begränsar företagets
              möjlighet att ta risker eller finansiera nya projekt.
            </p>
          </li>
        </ol>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Analysera orsaken: Förstå varför det egna kapitalet har minskat. Är
          det på grund av en förlust, utdelning eller något annat?
        </p>
        <p>
          Kontrollera soliditeten: Om eget kapital minskar kraftigt, påverkas
          soliditeten negativt, vilket innebär att företaget har en större andel
          skulder i förhållande till tillgångarna.
        </p>
        <p>
          Trend över tid: Se om minskningen är en engångshändelse eller en del
          av ett långsiktigt mönster. Enstaka förändringar är mindre oroande än
          en konstant minskning.
        </p>
        <p>
          Lönsamhet: Kontrollera företagets förmåga att generera framtida
          vinster som kan återställa eget kapital.
        </p>
      </div>
    ),
  },
};

triggerTexts[72] = {
  SE: {
    enum_key: 'MaterialAndImmaterialAssetsIncrease',
    trigger_id: 72,
    trigger_type: 'DEFAULT',
    name: 'Immateriella och materiella anläggningstillgångar ökat ständigt under en längre period',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          En stadig ökning av immateriella och materiella anläggningstillgångar
          kan vara ett positivt tecken på företagets ambition att växa och
          utvecklas. Samtidigt är det viktigt att säkerställa att dessa
          investeringar är välplanerade och bidrar till lönsamhet och långsiktig
          hållbarhet. För långivare och investerare är det klokt att analysera
          företagets balansräkning för att förstå om ökningen är rimlig och
          stödjer företagets övergripande mål.
        </p>
        <p>Investering i tillväxt:</p>
        <p>
          En stadig ökning av immateriella och materiella tillgångar kan tyda på
          att företaget expanderar eller förbereder sig för framtida tillväxt,
          t.ex. genom att köpa ny utrustning, utveckla programvara eller
          förvärva andra företag.
        </p>
        <p>Stora investeringskostnader:</p>
        <p>
          Om ökningen är betydande kan det innebära att företaget lägger stora
          resurser på investeringar, vilket kan påverka kassaflödet och
          likviditeten på kort sikt.
        </p>
        <p>Hög riskexponering:</p>
        <p>
          Om investeringarna inte leder till ökade intäkter eller effektivitet
          kan det innebära att företaget tar på sig onödiga risker. Detta gäller
          särskilt för immateriella tillgångar, som kan vara svåra att värdera
          eller sälja vidare.
        </p>
        <p>Långsiktig planering:</p>
        <p>
          En kontinuerlig ökning av dessa tillgångar kan indikera att företaget
          fokuserar på långsiktig stabilitet snarare än kortsiktiga vinster.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>Positiva tecken:</p>
        <ul>
          <li>
            <p>
              Företaget investerar i sin framtid och är fokuserat på att stärka
              sin konkurrenskraft.
            </p>
          </li>
          <li>
            <p>
              Tillgångarna kan öka företagets långsiktiga värde och
              avkastningspotential.
            </p>
          </li>
        </ul>
        <p>Risker att överväga:</p>
        <ul>
          <li>
            <p>
              För hög investeringstakt kan belasta företagets kassaflöde och
              minska soliditeten.
            </p>
          </li>
          <li>
            <p>
              Immateriella tillgångar kan vara svåra att värdera och sälja vid
              behov, vilket kan påverka återbetalningsförmågan.
            </p>
          </li>
          <li>
            <p>
              Ökningen kan dölja ineffektivitet, t.ex. investeringar i
              tillgångar som inte används optimalt.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[73] = {
  SE: {
    enum_key: 'NoSalesPreviousMonths',
    trigger_id: 73,
    trigger_type: 'DEFAULT',
    name: 'Innevarande månad är enda månaden med försäljning',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Xpektors algoritmer ger dig en varning när företaget inte haft någon
          försäljning tidigare månader. Xpektor mäter försäljning mellan månader
          för att uppmärksamma bedrägeri, bluffakturering och penningtvätt.
        </p>
        <p>
          Har bolaget endast omsättning i sista månaden bör man vara försiktig
          och sätta sig in i situationen.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          När ett bolag enbart redovisar omsättning i innevarande månad finns
          det flera viktiga aspekter att ta hänsyn till för att säkerställa en
          korrekt och säker hantering av denna information. Här är några
          centrala punkter att överväga:
        </p>
        <ul>
          <li>
            <p>Be företaget skicka ett utdrag från kundreskontran.</p>
          </li>
          <li>
            <p>
              Om bolaget har längre livslängd än ett år bör man ifrågasätta
              variationen kraftigt.
            </p>
          </li>
          <li>
            <p>
              Gå till rapporter i Xpektor och se på historiken på
              resultaträkningen.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[74] = {
  SE: {
    enum_key: 'SalesWithoutVatCosts',
    trigger_id: 74,
    trigger_type: 'DEFAULT',
    name: 'Ingen moms bokas med försäljning',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolag inte bokför moms i samband med försäljning innebär det
          att företaget inte redovisar moms på sina försäljningsintäkter, vilket
          bryter mot skattereglerna i många länder, inklusive Sverige. Företaget
          riskerar att inte uppfylla sina skyldigheter gentemot Skatteverket,
          vilket kan leda till böter, påminnelseavgifter eller andra rättsliga
          åtgärder. Detta kan också indikera att företaget inte är
          momsregistrerat eller medvetet försöker undvika att betala skatter.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska momsregistreringen: Kontrollera om företaget är
              registrerat för moms och om de följer Skatteverkets regler för
              momsredovisning. Är de medvetna om sina skyldigheter att redovisa
              moms?
            </p>
          </li>
          <li>
            <p>
              Undersök orsaker till utebliven moms: Be företaget förklara varför
              de inte bokför moms. Är det på grund av administrativa misstag,
              eller försöker de medvetet undvika att betala moms?
            </p>
          </li>
          <li>
            <p>
              Bedöm risken för skatteundandragande: Om företaget medvetet
              undviker att redovisa moms, kan det indikera skatteundandragande,
              vilket kan innebära allvarliga rättsliga och ekonomiska
              konsekvenser.
            </p>
          </li>
          <li>
            <p>
              Utvärdera affärsmodellen: Se om bolaget arbetar med produkter
              eller tjänster som faktiskt är undantagna från moms, och om det är
              så att företaget inte omfattas av momsreglerna av någon annan
              anledning.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt försiktig med ett bolag som inte
          bokför moms i samband med försäljning, eftersom detta kan tyda på
          skatteundandragande, bristande ekonomisk styrning eller administrativa
          brister. Det är viktigt att förstå orsakerna till detta och bedöma de
          potentiella rättsliga och finansiella riskerna för företaget. Om
          bolaget medvetet undviker att betala moms kan detta innebära
          allvarliga konsekvenser som kan påverka företagets långsiktiga
          stabilitet och dess förmåga att uppfylla sina åtaganden.
        </p>
      </div>
    ),
  },
};

triggerTexts[75] = {
  SE: {
    enum_key: 'DebtCollectors10',
    trigger_id: 75,
    trigger_type: 'DEFAULT',
    name: 'Inkasso mer än 10% av transaktionerna',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Utbetalningar till inkasso innebär att företaget har haft förfallna
          skulder som överlämnats till ett inkassobolag för indrivning. Detta
          kan tyda på att företaget haft problem att betala sina fakturor i tid,
          vilket kan signalera ekonomiska svårigheter eller brister i
          betalningsrutiner. Utbetalningar till inkasso är en varningssignal som
          kreditgivare bör ta på allvar. Det kan indikera såväl tillfälliga
          problem som långsiktiga ekonomiska utmaningar, och det är viktigt att
          förstå situationen innan kreditbeslut fattas.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om en förklaring: Fråga företaget varför betalningar gått till
              inkasso och vilka åtgärder de vidtagit för att förhindra att det
              händer igen.
            </p>
          </li>
          <li>
            <p>
              Analysera betalningshistorik: Se över bolagets bokföring och
              kassaflöde för att få en tydligare bild av dess betalningsförmåga.
            </p>
          </li>
          <li>
            <p>
              Ställ krav på förbättrade rutiner: Om möjligt, rekommendera att
              företaget implementerar bättre betalningsrutiner för att undvika
              framtida inkassokrav.
            </p>
          </li>
          <li>
            <p>
              Utred kreditrisk: Bolag med återkommande inkassoproblem kan
              innebära en högre risk som kräver säkerheter eller stramare
              villkor vid kreditgivning.
            </p>
          </li>
          <li>
            <p>
              Följ upp löpande: Vid beviljad kredit kan det vara bra att löpande
              följa upp företagets betalningsbeteende och ekonomiska utveckling.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[76] = {
  SE: {
    enum_key: 'DebtCollectors30',
    trigger_id: 76,
    trigger_type: 'DEFAULT',
    name: 'Inkasso mer än 30% av transaktionerna',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Utbetalningar till inkasso innebär att företaget har haft förfallna
          skulder som överlämnats till ett inkassobolag för indrivning. Detta
          kan tyda på att företaget haft problem att betala sina fakturor i tid,
          vilket kan signalera ekonomiska svårigheter eller brister i
          betalningsrutiner. Utbetalningar till inkasso är en varningssignal som
          kreditgivare bör ta på allvar. Det kan indikera såväl tillfälliga
          problem som långsiktiga ekonomiska utmaningar, och det är viktigt att
          förstå situationen innan kreditbeslut fattas.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om en förklaring: Fråga företaget varför betalningar gått till
              inkasso och vilka åtgärder de vidtagit för att förhindra att det
              händer igen.
            </p>
          </li>
          <li>
            <p>
              Analysera betalningshistorik: Se över bolagets bokföring och
              kassaflöde för att få en tydligare bild av dess betalningsförmåga.
            </p>
          </li>
          <li>
            <p>
              Ställ krav på förbättrade rutiner: Om möjligt, rekommendera att
              företaget implementerar bättre betalningsrutiner för att undvika
              framtida inkassokrav.
            </p>
          </li>
          <li>
            <p>
              Utred kreditrisk: Bolag med återkommande inkassoproblem kan
              innebära en högre risk som kräver säkerheter eller stramare
              villkor vid kreditgivning.
            </p>
          </li>
          <li>
            <p>
              Följ upp löpande: Vid beviljad kredit kan det vara bra att löpande
              följa upp företagets betalningsbeteende och ekonomiska utveckling.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[77] = {
  SE: {
    enum_key: 'DebtCollectors75',
    trigger_id: 77,
    trigger_type: 'DEFAULT',
    name: 'Inkasso mer än 75% av transaktionerna',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Utbetalningar till inkasso innebär att företaget har haft förfallna
          skulder som överlämnats till ett inkassobolag för indrivning. Detta
          kan tyda på att företaget haft problem att betala sina fakturor i tid,
          vilket kan signalera ekonomiska svårigheter eller brister i
          betalningsrutiner. Utbetalningar till inkasso är en varningssignal som
          kreditgivare bör ta på allvar. Det kan indikera såväl tillfälliga
          problem som långsiktiga ekonomiska utmaningar, och det är viktigt att
          förstå situationen innan kreditbeslut fattas.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om en förklaring: Fråga företaget varför betalningar gått till
              inkasso och vilka åtgärder de vidtagit för att förhindra att det
              händer igen.
            </p>
          </li>
          <li>
            <p>
              Analysera betalningshistorik: Se över bolagets bokföring och
              kassaflöde för att få en tydligare bild av dess betalningsförmåga.
            </p>
          </li>
          <li>
            <p>
              Ställ krav på förbättrade rutiner: Om möjligt, rekommendera att
              företaget implementerar bättre betalningsrutiner för att undvika
              framtida inkassokrav.
            </p>
          </li>
          <li>
            <p>
              Utred kreditrisk: Bolag med återkommande inkassoproblem kan
              innebära en högre risk som kräver säkerheter eller stramare
              villkor vid kreditgivning.
            </p>
          </li>
          <li>
            <p>
              Följ upp löpande: Vid beviljad kredit kan det vara bra att löpande
              följa upp företagets betalningsbeteende och ekonomiska utveckling.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[78] = {
  SE: {
    enum_key: 'KronofogdenPayments',
    trigger_id: 78,
    trigger_type: 'DEFAULT',
    name: 'Kronofogden',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företag gör utbetalningar till Kronofogden innebär det oftast
          att företaget har obetalda skulder som gått till indrivning. Detta kan
          tyda på att företaget har haft svårt att hantera sina
          betalningsåtaganden, vilket kan påverka dess ekonomiska stabilitet och
          kreditvärdighet. Utbetalningar till Kronofogden är en varningssignal
          som visar på tidigare eller pågående ekonomiska problem. Som
          kreditgivare är det viktigt att noggrant analysera situationen och
          företaget innan några kreditbeslut fattas.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om en uppdaterad balans- och resultatrapport samt
              kassaflödesanalys för att bedöma företagets ekonomiska läge.
            </p>
          </li>
          <li>
            <p>
              Undersök om bolaget har en tydlig plan för att hantera sina
              skulder och förbättra sin ekonomiska situation.
            </p>
          </li>
          <li>
            <p>
              Överväg att sätta särskilda villkor vid beviljande av kredit,
              exempelvis krav på ekonomisk rådgivning eller tätare uppföljning.
            </p>
          </li>
          <li>
            <p>
              Vid hög risk, utvärdera om säkerheter kan ställas för lånet eller
              om en kredit bör avslås tills situationen stabiliserats.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[79] = {
  SE: {
    enum_key: 'PaymentsOutPercentage',
    trigger_id: 79,
    trigger_type: 'DEFAULT',
    name: 'Utbetalningar mer än 55% av transaktionerna',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företag har utbetalningar som står för mer än 55% av
          transaktionerna på banken kan det vara ett tecken på att företaget har
          höga kostnader eller kassaflödesproblem. Kreditgivaren bör noggrant
          analysera företagets kassaflöde, kostnadsstruktur och
          betalningsförmåga för att säkerställa att företaget har en hållbar
          affärsmodell och kan fortsätta att uppfylla sina ekonomiska åtaganden.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kassaflödet noggrant: Det är viktigt att undersöka
              företagets kassaflöde för att säkerställa att de har tillräckligt
              med pengar för att täcka sina kostnader och återbetala lån utan
              att riskera insolvens.
            </p>
          </li>
          <li>
            <p>
              Analysera kostnadsstrukturen: Kreditgivaren bör undersöka
              företagets kostnadsstruktur och se om det finns några onödiga
              eller överdrivna utbetalningar som kan orsaka finansiell stress.
            </p>
          </li>
          <li>
            <p>
              Säkerställ att företaget har en hållbar affärsmodell: Om företaget
              har stora utbetalningar men inte motsvarande intäkter, bör
              kreditgivaren överväga om affärsmodellen är hållbar på lång sikt
              och om företaget kan klara av att hantera sina ekonomiska
              åtaganden.
            </p>
          </li>
          <li>
            <p>
              Utvärdera företagets betalningshistorik: Granska företagets
              betalningshistorik för att se om de regelbundet betalar sina
              skulder i tid, samt om det finns några tecken på
              betalningsproblem.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[80] = {
  SE: {
    enum_key: 'SwishPayments',
    trigger_id: 80,
    trigger_type: 'DEFAULT',
    name: 'Swish mer än 50% av transaktionerna',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företag har Swishbetalningar som står för mer än 50% av sina
          banktransaktioner kan det indikera en oreglerad inkomstström, där
          betalningarna inte alltid följer traditionella fakturerings- eller
          bokföringsrutiner. Kreditgivare bör vara noggranna med att kontrollera
          om dessa intäkter är korrekt redovisade, om företaget har några
          skatteproblem eller om det finns andra risker som kan påverka
          företagets framtida betalningsförmåga.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Begär detaljerad bokföring: Se till att företaget korrekt
              redovisar Swishbetalningarna i sin bokföring och kan
              tillhandahålla bevis på dessa transaktioner, som exempelvis
              sammanställningar från Swish och bankkontoutdrag.
            </p>
          </li>
          <li>
            <p>
              Granska inkomstflöden noggrant: Bedöm om företagets
              Swishbetalningar kommer från regelbundna kunder och om
              betalningarna är stabila. Kanske kan företaget behöva lägga till
              en mer formaliserad faktureringsprocess för att skapa en tydligare
              inkomstprofil.
            </p>
          </li>
          <li>
            <p>
              Kontrollera företagets skattehantering: Se till att företaget
              redovisar och betalar skatter korrekt på sina Swishintäkter. Fråga
              om eventuella skatteavtal eller betalningsplaner med Skatteverket.
            </p>
          </li>
          <li>
            <p>
              Analysera kassaflödet: Bedöm om det finns tillräcklig stabilitet i
              företagets kassaflöde, särskilt om Swishbetalningarna är osäkra
              eller mycket beroende av enstaka säsonger eller kampanjer.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[81] = {
  SE: {
    enum_key: 'Gambling',
    trigger_id: 81,
    trigger_type: 'DEFAULT',
    name: 'Spelsajter',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Att ett företag har utbetalningar till spelbolag kan innebära olika
          saker:
        </p>
        <ul>
          <li>
            <p>
              Privat användning av företagsmedel: Företagets konto används för
              privata spel, vilket inte är tillåtet enligt lag och kan indikera
              brist på ekonomisk kontroll.
            </p>
          </li>
          <li>
            <p>
              Hög riskbenägenhet: Om spelet är relaterat till företagets
              verksamhet kan det tyda på att bolaget tar finansiella risker som
              kan äventyra stabiliteten.
            </p>
          </li>
          <li>
            <p>
              Penningtvätt eller andra oegentligheter: Utbetalningar till
              spelbolag kan i vissa fall vara kopplade till försök att dölja
              pengar eller illegala aktiviteter.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <p>
          Utbetalningar som görs till spelbolag kan signalera finansiella risker
          som bör utredas innan kreditbeslut fattas.
        </p>
        <p>Tänk på:</p>
        <ul>
          <li>
            <p>
              Efterfråga en förklaring: Be företaget förtydliga varför dessa
              utbetalningar har gjorts och hur de är kopplade till verksamheten.
            </p>
          </li>
          <li>
            <p>
              Utvärdera ekonomisk kontroll: Återkommande utbetalningar till
              spelbolag kan indikera brist på ekonomiska rutiner och styrning.
            </p>
          </li>
          <li>
            <p>
              Undersök risker för långivaren: Om bolaget spelar bort medel
              riskerar det att sakna kapital för att täcka sina åtaganden,
              vilket kan påverka återbetalningsförmågan.
            </p>
          </li>
          <li>
            <p>
              Kontrollera om lagen följs: Privata utgifter får inte belasta
              bolaget enligt skattelagstiftningen. Sådana betalningar kan leda
              till skatterättsliga påföljder.
            </p>
          </li>
          <li>
            <p>
              Ta hänsyn till hur omfattande och återkommande dessa transaktioner
              är när du bedömer bolagets kreditvärdighet och riskprofil.
            </p>
          </li>
          <li>
            <p>
              Var uppmärksam på om transaktionerna kan kopplas till penningtvätt
              eller ekonomisk brottslighet och överväg att rapportera detta vid
              misstanke.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[82] = {
  SE: {
    enum_key: 'NoSKVPayments',
    trigger_id: 82,
    trigger_type: 'DEFAULT',
    name: 'Utbetalning till Skatteverket saknas',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företag inte har betalat sina skatter eller avgifter till
          Skatteverket kan det tyda på att företaget har ekonomiska svårigheter
          eller brister i sin likviditet. Det kan också innebära att företaget
          inte följer lagstadgade skyldigheter, vilket kan påverka deras förmåga
          att hantera sina ekonomiska åtaganden på ett ansvarsfullt sätt.
          Saknade betalningar till Skatteverket kan vara en allvarlig
          varningssignal för ekonomiska svårigheter. Kreditgivare bör noggrant
          utvärdera företagets förmåga att hantera sina skatter och
          förpliktelser innan ett lån beviljas, och överväga att ta extra
          försiktighetsåtgärder för att minska risken för att lånet inte
          återbetalas.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om förklaring: Företaget bör kunna förklara varför betalningar
              till Skatteverket saknas och ge en tydlig redogörelse för
              eventuella problem och deras lösning.
            </p>
          </li>
          <li>
            <p>
              Kontrollera betalningshistorik: Granska företagets tidigare
              skattebetalningar och säkerställ att det inte finns några
              långvariga eller upprepade förfallna skatter.
            </p>
          </li>
          <li>
            <p>
              Bedöm likviditeten: Om ett företag inte kan betala sina skatter
              kan det vara ett tecken på att de har problem med att generera
              tillräckligt med kassaflöde för att täcka sina förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Var försiktig med lånebeslut: Om företaget inte har betalat sina
              skatter kan det vara en varningssignal om potentiella ekonomiska
              problem. Överväg att skjuta upp eller avstå från att bevilja lån
              om riskerna bedöms som för höga.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[83] = {
  SE: {
    enum_key: 'SalaryWithoutSKVPayments',
    trigger_id: 83,
    trigger_type: 'DEFAULT',
    name: 'Lönekostnad men ingen betalning till Skatteverket',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företag har lönekostnader men saknar betalningar till
          Skatteverket kan det indikera likviditetsproblem, administrativa
          brister eller medveten skatteundandragelse. Kreditgivare bör noggrant
          undersöka orsakerna till detta och bedöma företagets framtida förmåga
          att hantera sina förpliktelser. Det är viktigt att ta hänsyn till
          riskerna med att bevilja lån till företag som inte följer sina
          skattebetalningsskyldigheter.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Förklaring från företaget: Begär en detaljerad förklaring om
              varför betalningar till Skatteverket inte har gjorts. Om det
              handlar om likviditetsproblem eller administrativa misstag kan det
              ge en bättre bild av riskerna.
            </p>
          </li>
          <li>
            <p>
              Granska företagets betalningshistorik: Kontrollera om detta är ett
              isolerat fall eller om företaget har en historia av att missköta
              betalningar till Skatteverket.
            </p>
          </li>
          <li>
            <p>
              Skatteåtgärder och påföljder: Ta reda på om Skatteverket har
              vidtagit åtgärder för att indriva de obetalda skatterna,
              exempelvis genom betalningsanmärkningar eller förhandlingar om
              betalningsplaner.
            </p>
          </li>
          <li>
            <p>
              Kassaflöde och likviditet: Företag med lönekostnader men utan
              betalningar till Skatteverket kan ha allvarliga
              likviditetsproblem. Det är viktigt att bedöma om företaget har
              förmågan att generera tillräckligt med kassaflöde för att täcka
              sina skatteåtaganden och löner i framtiden.
            </p>
          </li>
          <li>
            <p>
              Regelefterlevnad: Om företaget inte följer sina lagstadgade
              skyldigheter kan det innebära en högre risk för långivaren,
              eftersom detta kan leda till större finansiella problem eller
              rättsliga åtgärder.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[84] = {
  SE: {
    enum_key: 'PaymentsInGreaterThanRevenue',
    trigger_id: 84,
    trigger_type: 'DEFAULT',
    name: 'Inbetalningar på bank korrelerar ej med bokföringen',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          När inbetalningar som syns på bolagets bankkonto inte matchar de
          intäkter eller betalningar som är bokförda, tyder det på att det kan
          finnas brister i bokföringen eller att vissa transaktioner inte har
          registrerats korrekt. Det kan också innebära att vissa inbetalningar
          inte har rätt dokumentation, exempelvis fakturor, kvitton eller avtal.
        </p>
        <p>Det kan också bero på följande:</p>
        <ul>
          <li>
            <p>Fel eller försummelse vid bokföringen av intäkter.</p>
          </li>
          <li>
            <p>Privata transaktioner som blandas med företagets.</p>
          </li>
          <li>
            <p>Oregistrerade betalningar från kunder.</p>
          </li>
          <li>
            <p>
              Avvikelser i bokföringsrutiner eller användning av flera
              bankkonton utan översikt.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Efterfråga tydliga avstämningar mellan bankkonto och bokföring.
            </p>
          </li>
          <li>
            <p>
              Be företaget redogöra för vad avvikelserna beror på och hur de
              hanteras framöver.
            </p>
          </li>
          <li>
            <p>
              Om avvikelserna är återkommande, överväg att fråga om de har stöd
              av en auktoriserad redovisningskonsult.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[85] = {
  SE: {
    enum_key: 'PaymentsInMismatchInvoices',
    trigger_id: 85,
    trigger_type: 'DEFAULT',
    name: 'Genomsnittlig fakturering korrelerar ej med insättningar',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett bolags genomsnittliga fakturering inte korrelerar med
          inbetalningarna på banken kan det innebära att företaget inte får
          betalt för sina fakturor i tid eller att det finns problem med
          kundernas betalningsförmåga eller betalningsvilja. Detta kan skapa
          likviditetsproblem för företaget och påverka dess förmåga att täcka
          löpande kostnader och andra förpliktelser. Dessutom kan det vara ett
          tecken på oegentligheter såsom penningtvätt eller bedrägerier om
          betalningarna inte verkar motsvara faktureringen på ett realistiskt
          sätt.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska kundbetalningarna: Kontrollera om företaget har en hög
              andel förfallna kundfordringar eller långsamma betalningar. Be om
              en detaljerad uppföljning på utestående fakturor och kunder som
              inte betalar i tid.
            </p>
          </li>
          <li>
            <p>
              Utvärdera kundernas betalningshistorik: Bedöm om det är ett
              systematiskt problem med sena betalningar från kunder, och om
              detta beror på kunder med likviditetsproblem eller om det är ett
              tecken på andra faktorer.
            </p>
          </li>
          <li>
            <p>
              Följ upp företagets rutiner: Kontrollera om företaget har
              effektiva rutiner för att följa upp på fakturor, skicka
              påminnelser och vidta åtgärder vid försenade betalningar.
            </p>
          </li>
          <li>
            <p>
              Bedöm kassaflöde och likviditet: Eftersom långsamma
              kundinbetalningar kan påverka bolagets kassaflöde, bedöm om
              företaget har tillräcklig likviditet för att täcka sina
              kortsiktiga förpliktelser.
            </p>
          </li>
          <li>
            <p>
              Utvärdera risk för penningtvätt och bedrägeri: Om det finns stora
              skillnader mellan faktureringen och inbetalningarna, undersök om
              företaget kan vara involverat i penningtvätt eller bedrägerier.
              Kontrollera om transaktionerna verkar ovanligt komplexa eller
              oförenliga med bolagets affärsverksamhet.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett bolag vars
          fakturering inte korrelerar med inbetalningarna på banken, eftersom
          detta kan tyda på likviditetsproblem, långsamma kundbetalningar, eller
          bristande uppföljning av utestående fakturor. Det kan också vara en
          varningssignal för potentiella risker kopplade till penningtvätt eller
          bedrägerier. Det är viktigt att förstå orsakerna bakom dessa
          skillnader och bedöma företagets förmåga att hantera kundfordringar,
          säkerställa tillräcklig likviditet och förebygga olagliga aktiviteter.
        </p>
      </div>
    ),
  },
};

triggerTexts[86] = {
  SE: {
    enum_key: 'PaymentsOutMismatchSupplier',
    trigger_id: 86,
    trigger_type: 'DEFAULT',
    name: 'Utbetalningar på bank korrelerar ej med bokföringen',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om utbetalningar som syns på bolagets bankkonto inte stämmer överens
          med de kostnader eller betalningar som är registrerade i bokföringen,
          kan det tyda på att bokföringen inte är komplett eller korrekt. Det
          kan också innebära att vissa betalningar saknar underlag, till exempel
          kvitton, fakturor eller andra dokument.
        </p>
        <p>Det kan också bero på följande:</p>
        <ul>
          <li>
            <p>Felaktig eller glömd bokföring av betalningar.</p>
          </li>
          <li>
            <p>Privata utgifter som betalats via företagets konto.</p>
          </li>
          <li>
            <p>
              Bokföring som inte har uppdaterats med alla faktiska
              utbetalningar.
            </p>
          </li>
          <li>
            <p>
              Automatiska dragningar från bankkontot som inte är kända eller
              bokförda, exempelvis abonnemang eller skatter.
            </p>
          </li>
        </ul>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Efterfråga en förklaring till varför bokföringen inte stämmer med
              banktransaktionerna.
            </p>
          </li>
          <li>
            <p>
              Be om stödjande dokumentation, som fakturor och kvitton, för att
              kontrollera de avvikande betalningarna.
            </p>
          </li>
          <li>
            <p>
              Undersök om företaget har en tydlig rutin för löpande avstämning
              mellan bank och bokföring.
            </p>
          </li>
          <li>
            <p>
              Om avvikelserna är omfattande eller frekventa, överväg att föreslå
              att bolaget anlitar en redovisningskonsult för att säkerställa
              korrekta rutiner.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[87] = {
  SE: {
    enum_key: 'ATMWithdrawal',
    trigger_id: 87,
    trigger_type: 'DEFAULT',
    name: 'Kontantuttag bankomat',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Kontantuttag från bankomat innebär att företaget tar ut pengar direkt
          från sitt bankkonto i form av kontanter. Detta kan vara en normal del
          av verksamheten, särskilt för företag som hanterar mycket kontanter,
          men det kan också signalera brist på transparens eller andra risker.
          Som kreditgivare är det viktigt att säkerställa att uttagen är
          motiverade och redovisade på ett tydligt sätt. Frågor om syfte,
          transparens och riskhantering är avgörande för att bedöma om bolaget
          är en pålitlig låntagare.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om dokumentation: Företaget bör kunna redovisa hur
              kontantuttagen används, exempelvis genom kvitton eller
              kassajournaler.
            </p>
          </li>
          <li>
            <p>
              Utvärdera risk: Om kontantuttagen är höga eller verkar onödiga kan
              det finnas en ökad risk för oegentligheter eller bristande
              ekonomisk kontroll.
            </p>
          </li>
          <li>
            <p>
              Rekommendera digitala lösningar: Föreslå att företaget använder
              kort eller digitala betalningslösningar istället för kontanter, då
              det ger bättre spårbarhet och säkerhet.
            </p>
          </li>
          <li>
            <p>
              Bedöm ledningens kontroll: Kontanthantering kräver tydliga interna
              kontroller. Bedöm om företaget verkar ha tillräcklig styrning för
              att minska risken för missbruk.
            </p>
          </li>
          <li>
            <p>
              Varning för svarta pengar: Kontantuttag kan i vissa fall signalera
              risk för skattefusk eller odeklarerade affärer.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[88] = {
  SE: {
    enum_key: 'ATMDeposit',
    trigger_id: 88,
    trigger_type: 'DEFAULT',
    name: 'Kontant insättning bankomat',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Kontanta insättningar till bankomat innebär att företaget sätter in
          kontanter på sitt bankkonto via en bankomat eller insättningsmaskin.
          Detta kan vara normalt för företag som hanterar kontanter i sin
          verksamhet, men det kan också signalera vissa risker som bör
          utvärderas. Kreditgivare bör säkerställa att insättningarna är
          transparenta, motiverade och väl dokumenterade. Frågor om sambandet
          mellan insättningarna och företagets bokföring är avgörande för att
          bedöma risken i att bevilja lån.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Be om underlag: Företaget bör kunna styrka kontantinsättningarna
              med dokumentation, såsom kassajournaler, kvitton eller annan
              spårbarhet.
            </p>
          </li>
          <li>
            <p>
              Identifiera mönster: Stora, oregelbundna insättningar utan tydliga
              förklaringar kan tyda på dolda risker, som skattefusk eller
              penningtvätt.
            </p>
          </li>
          <li>
            <p>
              Utvärdera risker: Kontanthantering innebär högre risk för
              felaktigheter och oegentligheter, vilket kan påverka företagets
              stabilitet.
            </p>
          </li>
          <li>
            <p>
              Föreslå bättre rutiner: Rekommendera att företaget minskar sin
              kontanthantering genom att använda digitala betalningslösningar
              eller kortterminaler.
            </p>
          </li>
          <li>
            <p>
              Samarbeta med redovisningskonsult: Om det finns oklarheter kring
              insättningarna kan det vara bra att involvera en
              redovisningsexpert som kan analysera företagets ekonomiska
              struktur.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[89] = {
  SE: {
    enum_key: 'BankAccountsMismatch',
    trigger_id: 89,
    trigger_type: 'DEFAULT',
    name: 'Bankkonton matchar inte',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          Om ett företags bankkonton inte stämmer överens med de som finns
          redovisade i bokföringen kan det tyda på brister i företagets
          ekonomiska rutiner eller vara ett tecken på dolda risker. Det kan
          innebära att alla transaktioner inte bokförs korrekt eller att det
          finns konton som inte ingår i företagets officiella redovisning.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Efterfråga fullständig dokumentation: Be företaget lämna in
              kontoutdrag för alla bankkonton och förklara eventuella
              skillnader.
            </p>
          </li>
          <li>
            <p>
              Kontrollera mot bokföringen: Säkerställ att transaktioner från
              alla kända bankkonton är korrekt bokförda och redovisade.
            </p>
          </li>
          <li>
            <p>
              Anlita en expert: Om det finns stora skillnader kan det vara klokt
              att anlita en redovisningsexpert eller revisor för att utreda
              orsakerna.
            </p>
          </li>
          <li>
            <p>
              Bedöm företagets interna rutiner: Föreslå att företaget förbättrar
              sina bokförings- och ekonomirutiner för att säkerställa att alla
              konton inkluderas.
            </p>
          </li>
          <li>
            <p>
              Var försiktig vid lånebeslut: Om skillnaderna inte kan redas ut
              bör du överväga om det är lämpligt att bevilja lån.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

triggerTexts[901] = {
  SE: {
    enum_key: '=---NOT-SET---=',
    trigger_id: 901,
    trigger_type: 'DEFAULT',
    name: 'Byte av SNI-kod',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          En SNI-kod är en klassificering som används för att kategorisera
          företag baserat på den verksamhet de bedriver. Den används för
          statistiska ändamål och för att underlätta reglering och
          administration av skatter och andra krav. Om ett bolag har bytt
          SNI-kod innebär det att företaget har ändrat sin
          branschklassificering, vilket kan bero på förändringar i
          affärsmodellen eller verksamheten. Bytet kan också innebära att
          företaget har ändrat sin verksamhet så att den nu passar bättre inom
          en annan bransch. I vissa fall kan ett plötsligt byte av SNI-kod vara
          ett tecken på försök att dölja verksamhetens verkliga natur, vilket
          kan öka risken för bedrägerier eller penningtvätt.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska orsaker till bytet: Be företaget förklara varför de bytte
              SNI-kod och om det är en långsiktig förändring i affärsinriktning
              eller ett kortsiktigt experiment.
            </p>
          </li>
          <li>
            <p>
              Bedöm affärsmodellen: Förstå den nya affärsmodellen och om den
              verkar hållbar. Har företaget en tydlig strategi för att lyckas
              inom den nya branschen eller affärsområdet?
            </p>
          </li>
        </ul>
        <p>
          Utvärdera risken i den nya branschen: Undersök om den nya branschen
          innebär högre risker eller större potential för tillväxt jämfört med
          den tidigare verksamheten. Är branschen stabil, växande eller i
          nedgång?
        </p>
        <ul>
          <li>
            <p>
              Kontrollera den ekonomiska påverkan: Bedöm hur bytet påverkar
              företagets kassaflöde och lönsamhet. Kommer förändringen att leda
              till ökade intäkter, eller kan det medföra extra kostnader eller
              osäkerheter?
            </p>
          </li>
          <li>
            <p>
              Följ upp med framtidsutsikter: Be företaget om en plan för den nya
              verksamheten och om de har genomfört en marknadsundersökning eller
              affärsanalys för att säkerställa att bytet är ekonomiskt hållbart.
            </p>
          </li>
          <li>
            <p>
              Bedöm risken för bedrägeri och penningtvätt: Om bytet verkar
              plötsligt eller om det finns misstanke om att det syftar till att
              dölja verksamhetens verkliga natur, kan det indikera ett försök
              att genomföra bedrägerier eller penningtvätt. Kontrollera om
              transaktionerna eller företagsstrukturen verkar ovanliga eller
              otydliga.
            </p>
          </li>
        </ul>
        <p>
          Som kreditgivare bör du vara särskilt uppmärksam på ett bolag som bytt
          SNI-kod, eftersom det kan indikera en förändring i affärsmodellen
          eller en omstrukturering. Det kan även öka risken för bedrägerier
          eller penningtvätt, särskilt om bytet verkar oförklarligt eller är
          kopplat till oklara affärsaktiviteter. Det är viktigt att förstå
          orsakerna bakom bytet och noga bedöma om det finns tecken på
          oegentligheter eller försök att dölja bolagets verkliga verksamhet.
        </p>
      </div>
    ),
  },
};

triggerTexts[902] = {
  SE: {
    enum_key: '=---NOT-SET---=',
    trigger_id: 902,
    trigger_type: 'DEFAULT',
    name: 'Inbetalningar mer än 55% av transaktionerna',
    info: (
      /* ----- EXPLANATION ----- */ <div>
        <p>
          När ett företag har inbetalningar som står för mer än 55% av
          transaktionerna på banken kan detta tyda på att företaget har en stark
          likviditet på kort sikt, men det kan också innebära att inkomsterna är
          beroende av en oregelbunden eller osäker källa. Kreditgivare bör
          noggrant analysera intäkternas stabilitet och säkerställa att
          företaget har en långsiktig och hållbar affärsmodell för att minska
          risken för framtida betalningsproblem.
        </p>
      </div>
    ),
    tips: (
      /* ----- MEASURE ----- */ <div>
        <ul>
          <li>
            <p>
              Granska intäktskällorna: För att bättre förstå inbetalningarna,
              bör kreditgivaren begära detaljer om intäkternas ursprung. Är
              dessa inbetalningar återkommande eller är de baserade på
              tillfälliga försäljningar?
            </p>
          </li>
          <li>
            <p>
              Analysera kassaflödet: Se till att det finns ett stabilt
              kassaflöde, inte bara baserat på stora inbetalningar, utan också
              på ett sunt och långsiktigt inkomstflöde som stöder företagets
              tillväxt och skuldhantering.
            </p>
          </li>
          <li>
            <p>
              Kontrollera intäktsredovisningen: För att undvika framtida
              skatteproblem och osäkerhet, bör kreditgivaren säkerställa att
              alla inbetalningar är korrekt redovisade i bokföringen och följer
              gällande skatteregler.
            </p>
          </li>
          <li>
            <p>
              Bedöm långsiktig hållbarhet: Utvärdera om företagets affärsmodell
              och inkomstflöde är långsiktigt hållbara och inte enbart beroende
              på periodiska intäkter.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
};

export function GetTriggerTexts(id) {
  return {
    id,
    texts: triggerTexts[id].SE,
  };
}

export function TranslateTriggers(triggerIds) {
  const translated = [];
  for (let i = 0; i < triggerIds.length; i += 1) {
    if (triggerTexts[triggerIds[i]] !== undefined) {
      translated.push(GetTriggerTexts(triggerIds[i]));
    } else {
      translated.push({
        id: triggerIds[i],
        texts: { name: `ID: ${triggerIds[i]} Beskrivning saknas.` },
      });
    }
  }
  return translated;
}
